export default {
  'header.homepage': 'ホームページ',
  'header.workspace': 'ワークスペース',
  'login.title': 'Seedance',
  'login.welcome': 'Seedanceへようこそ',
  'login.description': 'Seedanceは、AI動画生成プラットフォームです。安全で便利な創作サービス。いつでもどこでもすべてのファイルにアクセスできます。',
  'login.email.placeholder': 'メールアドレスまたはユーザー名',
  'login.password.placeholder': 'パスワード',
  'login.button': 'ログイン',
  'login.loading': 'ログイン中...',
  'login.divider': 'または',
  'login.signup': 'アカウントをお持ちでない方',
  'login.signup.link': '新規登録',
  'login.error.default': 'ログインに失敗しました。後でもう一度お試しください',
  'login.success': 'ログインしました',
  'login.forgotPassword': 'パスワードをお忘れですか？',
  'login.forgotPassword.link': 'こちらでリセット',
  'login.rememberPassword': 'パスワードを記憶',
  'login.social.comingSoon': 'このログイン方式は準備中です',
  'captcha.placeholder': '認証コード',
  'captcha.refresh': '認証コードを更新',
  'auth.modal.title': 'ログインが必要です',
  'auth.modal.content': 'ログインの有効期限が切れたか、ログインしていません。続けるにはログインしてください。',
  'auth.modal.ok': 'ログインへ',
  'auth.modal.cancel': '後で',
  'login.verificationCode.placeholder': '認証コードを入力してください',
  'login.verificationCode.send': '認証コードを取得',
  'login.verificationCode.sending': '送信中...',
  'login.verificationCode.retry': '{seconds}秒後に再試行',
  'login.verificationCode.success': '認証コードが送信されました',
  'login.verificationCode.error': '認証コードの送信に失敗しました',
  'login.verificationCode.required': '認証コードを入力してください',
  'login.verificationCode.invalid': '認証コードの形式が正しくありません',
  'signup.page.title': '新規登録 - Seedance',
  'signup.title': 'Seedance',
  'signup.welcome': 'Seedanceへようこそ',
  'signup.description': 'アカウントを作成してAI創作の旅を始めましょう',
  'signup.feature.ai': 'AI駆動',
  'signup.feature.video': '動画制作',
  'signup.feature.fast': '高速生成',
  'signup.feature.creative': '無限の創造性',
  'signup.username.placeholder': 'ユーザー名を入力',
  'signup.email.placeholder': 'メールアドレスを入力',
  'signup.password.placeholder': 'パスワードを入力',
  'signup.confirmPassword.placeholder': 'パスワードを確認',
  'signup.inviteCode.placeholder': '招待コード（任意）',
  'signup.button': '登録',
  'signup.loading': '登録中...',
  'signup.login': 'すでにアカウントをお持ちの方',
  'signup.login.link': 'ログイン',
  'signup.error.passwordMismatch': 'パスワードが一致しません',
  'signup.error.default': '登録に失敗しました。後でもう一度お試しください',
  'signup.success': '登録が完了しました',
  'signup.username.rule.length': 'ユーザー名は4〜10文字である必要があります',
  'signup.username.rule.format': '文字、数字、アンダースコア、ハイフンのみ使用可能です',
  'signup.password.rule.length': 'パスワードは6〜20文字である必要があります',
  'signup.password.rule.lowercase': '小文字を含める必要があります',
  'signup.password.rule.uppercase': '大文字を含める必要があります',
  'signup.password.rule.number': '数字を含める必要があります',
  'signup.password.rule.special': '特殊文字を含める必要があります',
  'signup.verificationCode.placeholder': '認証コードを入力',
  'signup.verificationCode.send': '認証コードを取得',
  'signup.verificationCode.sending': '送信中...',
  'signup.verificationCode.retry': '{seconds}秒後に再試行',
  'signup.verificationCode.success': '認証コードを送信しました',
  'signup.verificationCode.error': '認証コードの送信に失敗しました',
  'signup.error.emailRequired': 'メールアドレスを入力してください',
  'signup.announcement': '本日は登録機能はメンテナンス中です！',
  'resetPassword.page.title': 'パスワードのリセット - Seedance',
  'resetPassword.page.description': 'Seedanceアカウントのパスワードをリセット',
  'resetPassword.title': 'パスワードのリセット',
  'resetPassword.email.placeholder': 'メールアドレスを入力',
  'resetPassword.code.placeholder': '認証コードを入力',
  'resetPassword.password.placeholder': '新しいパスワードを入力',
  'resetPassword.button': 'パスワードをリセット',
  'resetPassword.button.loading': 'リセット中...',
  'resetPassword.backToLogin': 'ログインに戻る',
  'resetPassword.sendCode': '認証コードを取得',
  'resetPassword.sendCode.sending': '送信中...',
  'resetPassword.sendCode.retry': '{seconds}秒後に再試行',
  'resetPassword.error.emailRequired': 'メールアドレスを入力してください',
  'resetPassword.error.codeRequired': '認証コードを入力してください',
  'resetPassword.error.passwordRequired': '新しいパスワードを入力してください',
  'resetPassword.error.passwordLength': 'パスワードは6-20文字で入力してください',
  'resetPassword.error.codeLength': '認証コードは6桁で入力してください',
  'resetPassword.success.codeSent': '認証コードをメールに送信しました',
  'resetPassword.success.reset': 'パスワードのリセットが完了しました',
  'resetPassword.error.sendFailed': '認証コードの送信に失敗しました。後でもう一度お試しください',
  'resetPassword.error.resetFailed': 'パスワードのリセットに失敗しました。後でもう一度お試しください',
  'resetPassword.error.incomplete': 'すべての必須項目を入力してください',
  'resetPassword.subtitle': 'メールアドレスと新しいパスワードを入力して、アカウントへのアクセスをリセットしてください。',
  'resetPassword.email.label': 'メールアドレス',
  'resetPassword.code.label': '認証コード',
  'resetPassword.password.label': '新しいパスワード',
  'resetPassword.success.title': 'リセット完了',
  'resetPassword.success.description': 'パスワードが正常に更新されました。新しいパスワードでログインできます。',
  'resetPassword.goToLogin': 'ログインへ',
  'resetPassword.promo.title': 'アカウントを保護し、創造性を守りましょう。',
  'resetPassword.promo.description': '銀行レベルのセキュリティプロトコルを導入し、お客様のデータと作品が確実にお客様のものとなるようにしています。',
  'sidebar.create': '作成',
  'sidebar.allFiles': 'すべてのファイル',
  'sidebar.starred': 'お気に入り',
  'sidebar.folders': 'フォルダ',
  'sidebar.trash': 'ゴミ箱',
  'sidebar.decrypt': '復号化ツール',
  'sidebar.promptMarket': 'プロンプトマーケット',
  'sidebar.channels': '生成チャンネル',
  'sidebar.dailyChallenge': 'デイリーチャレンジ',
  'sidebar.mediaTools': 'メディアツール',
  'sidebar.storageNodes': 'ストレージノード',
  'create.tab.textToImage': 'テキストから画像',
  'create.tab.textToVideo': 'テキストから動画',
  'create.tab.imageToImage': '画像から画像',
  'create.tab.imageToVideo': '画像から動画',
  'create.tab.seedanceVideo': 'Seedance 画像から動画',
  'create.seedance.title': 'Seedance 画像から動画',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5、画像駆動のショート動画生成',
  'create.seedance.noModel': '利用可能な Seedance モデルがありません。管理画面で設定してください。',
  'create.seedance.cameraFixed': 'カメラ固定',
  'create.seedance.cameraFixed.true': 'はい（固定）',
  'create.seedance.cameraFixed.false': 'いいえ（動的）',
  'create.seedance.watermark': 'ウォーターマークを追加',
  'create.seedance.watermark.true': 'はい',
  'create.seedance.watermark.false': 'いいえ',
  'create.textToImage.title': 'テキストから画像',
  'create.textToImage.subtitle': '説明を入力して、AIにあなたの心の中の画像を描かせましょう',
  'create.textToImage.description': 'テキストの説明から画像を生成します。この機能は開発中です...',
  'create.textToVideo.title': 'テキストから動画',
  'create.textToVideo.subtitle': 'シーンの説明とカメラコントロールを入力して、高品質な動画を生成',
  'create.textToVideo.description': 'テキストの説明から動画を生成します。この機能は開発中です...',
  'create.imageToImage.title': '画像から画像',
  'create.imageToImage.description': '参照画像から新しい画像を生成します。この機能は開発中です...',
  'create.imageToVideo.title': '画像から動画',
  'create.imageToVideo.description': '参照画像から動画を生成します。この機能は開発中です...',
  'sidebar.feedback': 'フィードバック',
  'sidebar.about': '概要',
  'sidebar.productLog': '更新履歴',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': 'トップクリエイターのAIインスピレーションで、無限の創造力を解放',
  'promptMarket.searchPlaceholder': 'Prompt、スタイル、モデルを検索...',
  'promptMarket.search': '検索',
  'promptMarket.all': 'すべて',
  'promptMarket.tabAll': 'おすすめ',
  'promptMarket.tabImage': '文生図',
  'promptMarket.tabVideo': '文生動画',
  'promptMarket.tabAudio': '文生音楽',
  'promptMarket.sortLatest': '最新',
  'promptMarket.sortHot': '人気',
  'promptMarket.sortSales': '売れ筋',
  'promptMarket.publish': '作品を公開',
  'promptMarket.empty': '該当商品がありません。最初の作品を公開しましょう！',
  'promptMarket.free': '無料',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': '読み込みに失敗しました',
  'promptMarket.listSuccess': '出品しました',
  'promptMarket.listFailed': '出品に失敗しました',
  'market.label': 'プロンプトマーケット',
  'market.h1': 'あなたの',
  'market.h1.highlight': '創造性を解放。',
  'market.sub': 'AIプロンプトのプレミアムプラットフォーム。画像・動画・音楽に対応。OpenAI、Google、Midjourney、Runway、Kling、Luma、Suno、ElevenLabsなど、検証済みレシピで試行錯誤なしに創作を。',
  'market.providers.title': '主要モデル・プラットフォームに対応',
  'market.card1.title': '即座に連携',
  'market.card1.desc': 'プロンプト学習の長い曲線をスキップ。実戦で使えるプロンプトをワンクリックでワークフローに取り込み。',
  'market.card2.title': 'クリエイティブを収益化',
  'market.card2.desc': '最高のプロンプトをパッシブインカムに。AIの専門性で収益を得る何千ものクリエイターに参加。',
  'market.card3.title': '品質保証',
  'market.card3.desc': 'すべての出品は手動で審査・テスト。異なるモデルでも安定した結果を保証。',
  'market.card4.title': 'ラボを探索',
  'market.card4.desc': 'コミュニティが生成した10,000以上のアセットを発見。',
  'market.cta': 'プロンプトマーケットへ',
  'home.mediaTools.title': 'メディアツール',
  'home.mediaTools.subtitle': 'オンラインで利用、インストール不要。画像・動画・音声を簡単に処理。',
  'home.mediaTools.toolSuffix': 'ツール',
  'home.mediaTools.imageCompress.title': '画像圧縮',
  'home.mediaTools.imageCompress.description': '画質を保ちながらスマートに圧縮。バッチ処理対応。',
  'home.mediaTools.videoCompress.title': '動画圧縮',
  'home.mediaTools.videoCompress.description': '解像度・ビットレートをカスタム可能。複数形式対応。',
  'home.mediaTools.audioCompress.title': '音声圧縮',
  'home.mediaTools.audioCompress.description': '音質を保ちながらファイルサイズを最適化。MP3、AAC等対応。',
  'filelist.column.name': '名前',
  'filelist.column.size': 'サイズ',
  'filelist.column.updateTime': '更新日時',
  'filelist.column.recycletime': '削除日時',
  'filelist.column.actions': '操作',
  'filelist.total': '合計 {total} 件',
  'filelist.action.upload': 'アップロード',
  'filelist.action.newFolder': '新規フォルダ',
  'filelist.action.refresh': '更新',
  'filelist.action.search': 'ファイル検索',
  'filelist.action.batchDownload': 'ダウンロード',
  'filelist.action.batchDelete': '削除',
  'filelist.action.download': 'ダウンロード',
  'filelist.action.preview': 'プレビュー',
  'filelist.action.rename': '名前変更',
  'filelist.selected': '{count} 件選択',
  'page.cloudDrive.title': 'マイクラウドドライブ',
  'page.cloudDrive.description': 'AIMATEX クラウドドライブ - 安全にファイルを保存・管理',
  'modal.fileUpload.title': 'ファイルアップロード',
  'modal.fileUpload.dragText': 'ここにファイルをドラッグ、またはクリックしてアップロード',
  'modal.fileUpload.start': 'アップロード開始',
  'modal.fileUpload.cancel': 'キャンセル',
  'modal.fileUpload.clear': 'リストをクリア',
  'modal.fileUpload.encrypt': '選択したファイルを暗号化',
  'modal.fileUpload.addMore': '追加',
  'modal.fileUpload.remove': '削除',
  'modal.fileUpload.error.noSelection': '削除するファイルを選択してください',
  'modal.fileUpload.error.noEncryption': '暗号化するファイルを選択してください',
  'modal.fileUpload.error.noClear': 'クリアするファイルがありません',
  'modal.fileUpload.error.noStart': 'アップロードするファイルがありません',
  'modal.fileUpload.error.noCancel': 'キャンセルするアップロードがありません',
  'modal.fileUpload.error.fileSize': 'ファイルサイズが制限を超えています',
  'modal.fileUpload.error.fileType': '対応していないファイル形式です',
  'modal.fileUpload.error.maxCount': 'ファイル数が制限を超えています',
  'modal.fileUpload.duplicate.title': 'ファイルが既に存在します',
  'modal.fileUpload.duplicate.skip': 'スキップ',
  'modal.fileUpload.duplicate.replace': '置き換え',
  'modal.fileUpload.duplicate.rename': '名前変更',
  'modal.fileUpload.status.pending': '待機中',
  'modal.fileUpload.status.uploading': 'アップロード中',
  'modal.fileUpload.status.success': '完了',
  'modal.fileUpload.status.error': 'エラー',
  'modal.fileUpload.status.cancelled': 'キャンセル',
  'modal.fileUpload.status.duplicated': '重複',
  'modal.fileUpload.table.filename': 'ファイル名',
  'modal.fileUpload.table.size': 'サイズ',
  'modal.fileUpload.table.status': '状態',
  'modal.fileUpload.table.progress': '進捗',
  'modal.fileUpload.table.actions': '操作',
  'modal.fileUpload.speed': 'アップロード速度',
  'modal.fileUpload.remainingTime': '残り時間',
  'modal.fileUpload.total.progress': '全体の進捗',
  'modal.fileUpload.error.message': 'アップロード失敗: {message}',
  'modal.fileUpload.confirm.clear': 'アップロードリストをクリアしますか？',
  'modal.fileUpload.confirm.cancel': 'アップロードをキャンセルしますか？',
  'modal.fileUpload.clear.mobile': 'クリア',
  'modal.fileUpload.encrypt.mobile': '暗号化',
  'modal.fileUpload.addMore.mobile': '追加',
  'productLog.title': '更新履歴',
  'security.features.title': 'セキュリティ機能',
  'security.features.localDecryption.title': 'ローカル復号化',
  'security.features.localDecryption.description': 'すべての復号化操作はブラウザ内で実行され、ファイル内容とパスワードがデバイスから外部に送信されることはありません',
  'security.features.militaryEncryption.title': '軍事級暗号化',
  'security.features.militaryEncryption.description': 'AES-256-CBC暗号化アルゴリズムを使用。既知のすべての攻撃に耐えうる最も安全な対称暗号化規格です',
  'security.features.privacyProtection.title': 'プライバシー保護',
  'security.features.privacyProtection.description': '厳格なプライバシー保護メカニズムにより、復号化パスワードは保存されず、ファイル内容も記録されません',
  'security.features.smartDecryption.title': 'スマートチャンク復号化',
  'security.features.smartDecryption.description': 'スマートチャンク復号化技術により、復号化速度を大幅に向上させながらメモリ使用量を削減します',
  'security.features.learnMore': '詳細を見る',
  'security.features.modal.title': 'セキュリティ機能の詳細',
  'security.features.modal.close': '閉じる',
  'decrypt.security.modal.title': 'セキュリティ通知',
  'decrypt.security.modal.description': 'すべての復号化操作はローカルで実行され、パスワードやファイル内容がサーバーにアップロードされることはありません',
  'decrypt.security.modal.vip.title': 'VIPユーザーの特典：',
  'decrypt.security.modal.vip.feature1': 'どんなサイズのファイルも復号化可能',
  'decrypt.security.modal.vip.feature2': 'スマートチャンク復号化で効率アップ',
  'decrypt.security.modal.vip.feature3': '大容量ファイルの一括復号化に対応',
  'decrypt.security.modal.free.title': '重要：復号化にはファイルサイズの約3倍のブラウザメモリが必要です。',
  'decrypt.security.modal.free.feature1': '無料ユーザーは1ファイル4GBまで',
  'decrypt.security.modal.free.feature2': 'VIPにアップグレードで容量制限解除',
  'decrypt.security.modal.free.feature3': 'ブラウザがクラッシュする場合はVIPのチャンク復号化機能の利用を検討してください',
  'security.diagram.plaintext.block1': '平文ブロック1',
  'security.diagram.plaintext.block2': '平文ブロック2',
  'security.diagram.ciphertext.block1': '暗号文ブロック1',
  'security.diagram.ciphertext.block2': '暗号文ブロック2',
  'security.diagram.key': '鍵',
  'security.diagram.aes.encryption': 'AES暗号化',
  'security.diagram.xor.operation': 'XOR演算',
  'security.diagram.iv': '初期化ベクトル',
  'security.features.chunk.title': 'スマートチャンク復号化技術',
  'security.features.chunk.what': 'スマートチャンク復号化とは？',
  'security.features.chunk.description': 'スマートチャンク復号化は、大容量ファイルのために最適化された技術で、ファイルを複数のブロックに分割して並列処理を行い、以下の特徴があります：',
  'security.features.chunk.feature1.title': '動的分割',
  'security.features.chunk.feature1.desc': 'ファイルサイズとシステムメモリに基づいてブロックサイズを自動調整',
  'security.features.chunk.feature2.title': '並列処理',
  'security.features.chunk.feature2.desc': '複数のデータブロックを同時に復号化し、マルチコアCPUを最大限活用',
  'security.features.chunk.feature3.title': 'メモリ最適化',
  'security.features.chunk.feature3.desc': 'ストリーミング処理によりメモリ使用を制御し、オーバーフローを防止',
  'security.features.chunk.feature4.title': '再開サポート',
  'security.features.chunk.feature4.desc': '中断後の継続をサポートし、耐障害性を向上',
  'security.features.chunk.how': '動作の仕組み',
  'security.features.chunk.process': 'スマートチャンク復号化プロセスには以下のステップが含まれます：',
  'security.features.chunk.step1': 'ファイル分析：最適なブロックサイズと数を計算',
  'security.features.chunk.step2': 'データ分割：暗号化ファイルを同サイズのブロックに分割',
  'security.features.chunk.step3': '並列復号化：複数のブロックを同時に復号化',
  'security.features.chunk.step4': 'ストリーム書き込み：復号化されたブロックを順次書き込み',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'パフォーマンスの利点',
  'security.features.chunk.performance.intro': '従来の復号化と比較して、スマートチャンク復号化には以下の大きな利点があります：',
  'security.features.chunk.performance.point1': 'メモリ使用量を最大90%削減、4GBファイルに400MBのみ必要',
  'security.features.chunk.performance.point2': 'マルチコアCPUを活用し、3-5倍高速な復号化速度',
  'security.features.chunk.performance.point3': '大容量ファイル(>4GB)の復号化をサポート、ブラウザメモリ制限なし',
  'security.features.chunk.performance.point4': '正確な進捗と残り時間を表示する視覚的な復号化プロセス',
  'security.features.chunk.usage': '使用例',
  'security.features.chunk.usage.intro': 'スマートチャンク復号化は以下のシナリオに特に適しています：',
  'security.features.chunk.usage.point1': '大容量ファイルの復号化（例：動画、データベースバックアップ）',
  'security.features.chunk.usage.point2': 'メモリ制限のあるデバイスでの復号化操作',
  'security.features.chunk.usage.point3': '並列処理が必要な一括復号化',
  'security.features.chunk.usage.point4': 'リアルタイムフィードバックが必要な復号化タスク',
  'security.features.chunk.diagram': 'スマートチャンク復号化プロセス図',
  'security.features.aes.security': 'セキュリティ特性',
  'security.features.aes.security.intro': 'AES-256-CBCは以下の複数のセキュリティ保証を提供します：',
  'security.features.aes.security.point1': '256ビットキーは2^256の組み合わせを提供し、スーパーコンピュータでも総当たり攻撃は不可能',
  'security.features.aes.security.point2': 'CBCモードにより、同一の平文ブロックが異なる暗号文ブロックを生成し、暗号化のランダム性を向上',
  'security.features.aes.security.point3': '初期化ベクトル（IV）の使用により、同じキーを使用しても毎回異なる暗号化結果を保証',
  'security.features.aes.security.point4': '軍事、金融、その他の高度なセキュリティが要求される分野で広く使用',
  'security.features.aes.diagram': 'CBCモード暗号化プロセスの動的図解',
  'security.features.aes.why': 'なぜAES-256-CBCを選択したのか？',
  'security.features.aes.why.intro': '以下の理由でAES-256-CBCを暗号化標準として選択しました：',
  'security.features.aes.why.point1': '広く検証されたセキュリティ、現在まで実用的な攻撃手法なし',
  'security.features.aes.why.point2': '優れたパフォーマンス、高速な暗号化と復号化',
  'security.features.aes.why.point3': 'ハードウェアアクセラレーション対応、現代のプロセッサにAES命令セットを内蔵',
  'security.features.aes.why.point4': '広範なツールサポート、すべてのプログラミング言語で成熟した実装',
  'security.features.aes.what': 'AES-256-CBCとは？',
  'security.features.aes.description': 'AES-256-CBCは高度暗号化標準（Advanced Encryption Standard）の実装の一つで、以下の特徴があります：',
  'security.features.aes.detail.1': '2001年に米国国立標準技術研究所（NIST）によって制定された対称暗号化アルゴリズム',
  'security.features.aes.detail.2': '256ビットの鍵長を使用し、最高レベルのセキュリティを提供',
  'security.features.aes.detail.3': '暗号ブロック連鎖（Cipher Block Chaining）モードによる、より強力な暗号化セキュリティ',
  'security.features.aes.how': '動作の仕組み',
  'security.features.aes.process': 'AES-256-CBC暗号化プロセスには以下のステップが含まれます：',
  'security.features.aes.step1': '平文データを固定サイズのブロック（128ビット）に分割',
  'security.features.aes.step2': 'ランダムな初期化ベクトル（IV）を生成',
  'security.features.aes.step3': 'CBCモードを使用して前の暗号文ブロックと現在の平文ブロックをXOR演算',
  'security.features.aes.step4': '256ビット鍵を使用してXOR結果にAES暗号化を実行',
  'security.features.aes.example': '暗号化プロセスの例：',
  'decrypt.fileList.column.name': 'ファイル名',
  'decrypt.fileList.column.status': 'ステータス',
  'decrypt.fileList.column.actions': '操作',
  'decrypt.fileList.status.pending': '待機中',
  'decrypt.fileList.status.decrypting': '復号化中',
  'decrypt.fileList.status.success': '完了',
  'decrypt.fileList.status.error': 'エラー',
  'decrypt.fileList.action.info': '情報',
  'decrypt.fileList.empty': 'ファイルがありません。復号化するファイルを追加してください',
  'common.unknown': '不明',
  'common.philosophy': '技術は人々のために',
  'common.speed': '速度',
  'common.timeSpent': '経過時間',
  'common.remaining': '残り時間',
  'decrypt.upload.dragText': 'クリックまたはドラッグでファイルを追加',
  'decrypt.upload.hint': '.encryptedファイルの一括追加に対応、ファイルあたり最大 {maxSize}',
  'decrypt.upload.button.decrypt': '選択したファイルを復号化',
  'decrypt.upload.button.clear': 'リストをクリア',
  'page.decrypt.title': 'MyStorage ファイル復号化ツール',
  'page.decrypt.subtitle': '安全にファイルを復号化',
  'page.decrypt.helmet.title': 'ファイル復号化ツール - MyStorage',
  'page.decrypt.helmet.description': '安全なファイル復号化ツール - ブラウザでローカルに復号化してプライバシーを保護',
  'decrypt.fileInfo.modal.title': 'ファイル情報',
  'decrypt.fileInfo.modal.close': '閉じる',
  'decrypt.fileInfo.name': 'ファイル名',
  'decrypt.fileInfo.size': 'ファイルサイズ',
  'decrypt.fileInfo.type': 'ファイルタイプ',
  'decrypt.fileInfo.lastModified': '最終更新日時',
  'decrypt.fileInfo.status': 'ステータス',
  'decrypt.fileInfo.progress': '進捗',
  'decrypt.fileInfo.speed': '速度',
  'decrypt.fileInfo.timeRemaining': '残り時間',
  'decrypt.fileInfo.timeSpent': '経過時間',
  'decrypt.fileInfo.error': 'エラーメッセージ',
  'decrypt.password.modal.title': '復号化パスワードを入力',
  'decrypt.password.modal.placeholder': 'パスワードを入力',
  'decrypt.password.modal.hint': '暗号化時に設定したパスワードを入力してください。パスワードはローカルでの復号化にのみ使用されます',
  'decrypt.message.invalidFile': '.encryptedファイルのみ選択可能です',
  'decrypt.message.duplicate': 'ファイル "{filename}" は既に存在します。自動的に重複を除去しました',
  'decrypt.message.oversizeTitle': 'ファイルサイズ制限超過',
  'decrypt.message.oversizeContent': '以下のファイルが無料ユーザーの制限(4GB)を超えています：',
  'decrypt.message.oversizeHint': 'VIPにアップグレードで容量無制限に',
  'decrypt.message.selectFile': '復号化するファイルを選択してください',
  'decrypt.message.enterPassword': '復号化パスワードを入力してください',
  'decrypt.message.decryptSuccess': 'ファイル {filename} を保存しました',
  'decrypt.message.saveCancel': 'ファイル {filename} の保存をキャンセルしました',
  'decrypt.message.downloadSuccess': 'ファイル {filename} をダウンロードフォルダに保存しました',
  'decrypt.message.decryptError': 'ファイル {filename} の復号化に失敗: {error}',
  'decrypt.message.batchError': '一括復号化に失敗しました。もう一度お試しください',
  'modal.newFolder.title': '新規フォルダ',
  'modal.newFolder.placeholder': 'フォルダ名を入力',
  'modal.newFolder.ok': '作成',
  'modal.newFolder.cancel': 'キャンセル',
  'filelist.modal.rename.title': '名前変更',
  'filelist.modal.rename.placeholder': '新しい名前を入力',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'キャンセル',
  'sideMenu.storageInfo.title': 'ストレージ容量',
  'sideMenu.storageInfo.usage': '使用中 {used} / 合計 {total}',
  'sideMenu.storageStats.title': 'ストレージ統計',
  'sideMenu.storageStats.overview': '概要',
  'sideMenu.storageStats.totalFiles': '総ファイル数',
  'sideMenu.storageStats.totalSize': '総容量',
  'sideMenu.storageStats.fileTypes': 'ファイルタイプ分布',
  'sideMenu.storageStats.providers': 'サービスプロバイダー',
  'common.default': 'デフォルト',
  'common.regionCode': 'リージョンコード',
  'common.nodeType': 'ノードタイプ',
  'common.storageUsed': '使用済み容量',
  'common.storageAvailable': '利用可能容量',
  'common.storageLimit': '総容量',
  'common.storageUsageDetail': '使用中 {used} / 合計 {total}',
  'common.defaultNode': 'デフォルトノード',
  'common.confirm': '確認',
  'common.cancel': 'キャンセル',
  'common.latency': 'レイテンシ',
  'common.retry': '再試行',
  'cloudDrive.nodeSelect.title': 'ストレージノードを選択',
  'cloudDrive.nodeSelect.addNode': 'ストレージノードを追加',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'ノード削除の確認',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'ノード「{nodeName}」を削除してもよろしいですか？この操作は元に戻せません！',
  'cloudDrive.nodeSelect.deleteSuccess': 'ノードが正常に削除されました',
  'cloudDrive.nodeSelect.deleteFailed': 'ノードの削除に失敗しました',
  
  // ノード作成
  'cloudDrive.nodeCreate.title': 'ストレージノードを追加',
  'cloudDrive.nodeCreate.selectProvider': 'クラウドプロバイダーを選択',
  'cloudDrive.nodeCreate.nodeName': 'ノード名',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': '空欄の場合はデフォルト名を使用します',
  'cloudDrive.nodeCreate.nameMaxLength': 'ノード名は50文字を超えることはできません',
  'cloudDrive.nodeCreate.noProviders': '利用可能なクラウドプロバイダーがありません',
  'cloudDrive.nodeCreate.pingLatency': 'レイテンシ {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'レイテンシをテスト中...',
  'cloudDrive.nodeCreate.pingFailed': 'レイテンシテストに失敗しました',
  'cloudDrive.nodeCreate.pingUnavailable': 'レイテンシテストは利用できません',
  'cloudDrive.nodeCreate.sortByLatency': 'レイテンシで並び替え',
  'cloudDrive.nodeCreate.selectRegion': 'リージョンを選択',
  'cloudDrive.nodeCreate.selectedRegion': '選択されたリージョン',
  'cloudDrive.nodeCreate.noRegions': '利用可能なリージョンがありません',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'クラウドプロバイダーを選択してください',
  'cloudDrive.nodeCreate.selectProviderRequired': 'まずクラウドプロバイダーを選択してください',
  'cloudDrive.nodeCreate.selectRegionRequired': 'まずリージョンを選択してください',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'クラウドプロバイダーリストの読み込みに失敗しました',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'リージョンリストの読み込みに失敗しました',
  'cloudDrive.nodeCreate.nodeType': 'ノードタイプ',
  'cloudDrive.nodeCreate.nodeType.standard': '標準ストレージ',
  'cloudDrive.nodeCreate.nodeType.lowFreq': '低頻度ストレージ',
  'cloudDrive.nodeCreate.nodeType.archive': 'アーカイブストレージ',
  'cloudDrive.nodeCreate.storageLimit': 'ストレージ制限',
  'cloudDrive.nodeCreate.storageLimitRequired': 'ストレージ制限を入力してください',
  'cloudDrive.nodeCreate.storageLimitMin': 'ストレージ制限は1GB未満にできません',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'ストレージ制限を入力してください（GB）',
  'cloudDrive.nodeCreate.success': 'ストレージノードが正常に作成されました',
  'cloudDrive.nodeCreate.failed': 'ストレージノードの作成に失敗しました',
  
  // ノード編集
  'cloudDrive.nodeEdit.title': 'ノードを編集',
  'cloudDrive.nodeEdit.name': 'ノード名',
  'cloudDrive.nodeEdit.nameRequired': 'ノード名を入力してください',
  'cloudDrive.nodeEdit.nameMaxLength': 'ノード名は50文字を超えることはできません',
  
  // TextToImage page internationalization
  'create.prompt': 'プロンプト',
  'create.prompt.placeholder': '例：宇宙を歩くサイバーパンクの猫、ネオン背景、高詳細...',
  'create.prompt.required': 'プロンプトを入力してください',
  'create.prompt.generate': 'AI プロンプト生成',
  'create.prompt.enrich': 'AI プロンプト強化',
  'create.prompt.generate.success': 'プロンプトが正常に生成されました！',
  'create.prompt.generate.error': 'プロンプトの生成に失敗しました。もう一度お試しください',
  'create.prompt.generate.empty': 'プロンプトが生成されませんでした。もう一度お試しください',
  'create.prompt.restore': '復元',
  'create.prompt.restore.success': '元のプロンプトに復元しました',
  'create.prompt.restore.tooltip': 'AI生成/強化前のプロンプトに復元',
  'create.ratio': 'アスペクト比',
  'create.style': 'アートスタイル',
  'create.batchSize': '生成数',
  'create.generate': '今すぐ生成',
  'create.negativePrompt.tooltip': '画像に含めたくない要素',
  'create.negativePrompt.placeholder': '例：ぼやけ、低品質、変形した指...',
  'create.generating': '生成中...',
  'create.generating.waiting': 'AIが作成中です。お待ちください...',
  'create.result.title': '生成結果',
  'create.downloadAll': 'すべてダウンロード',
  'create.aspectRatio.1:1': '1:1 (正方形)',
  'create.aspectRatio.16:9': '16:9 (横向き)',
  'create.aspectRatio.9:16': '9:16 (縦向き)',
  'create.aspectRatio.21:9': '21:9 (シネマ)',
  'create.aspectRatio.4:3': '4:3 (クラシック)',
  'create.style.general': '一般',
  'create.style.anime': 'アニメ',
  'create.style.realistic': 'リアル',
  'create.style.3d-render': '3Dレンダー',
  'create.style.cyberpunk': 'サイバーパンク',
  'create.settings.loadFailed': '作成タイプ設定の読み込みに失敗しました。すべてのオプションを表示します',
  'create.settings.error': '設定の読み込みに失敗しました。すべてのオプションを表示します',
  'create.noAvailableTabs': '利用可能な作成タイプがありません',
  'create.network.error.title': 'ネットワーク接続エラー',
  'create.network.error.description': '作成タイプ設定を読み込めません。ネットワーク接続を確認してページを更新してください',
  'create.network.error.refresh': 'ページを更新',
  
  // TextToVideo page internationalization
  'create.prompt.video': '動画シーン説明 (Prompt)',
  'create.prompt.video.placeholder': '例：月面で踊る宇宙飛行士の犬、8K、映画的照明、シュールレアリスム。',
  'create.prompt.video.required': '動画シーン説明を入力してください',
  'create.generate.video': '今すぐ動画を生成',
  'create.video.ratio': '動画アスペクト比',
  'create.video.camera': 'カメラモーション',
  'create.video.duration': '動画の長さ (秒)',
  'create.video.format': '出力形式',
  'create.cameraMotion.none': '動きなし (None)',
  'create.cameraMotion.zoomIn': 'ズームイン (Zoom In)',
  'create.cameraMotion.dollyOut': 'ドリーアウト (Dolly Out)',
  'create.cameraMotion.panLeft': '左パン (Pan Left)',
  'create.cameraMotion.tiltUp': '上チルト (Tilt Up)',
  'create.cameraMotion.orbital': '360° オービタル',
  'create.negativePrompt.video.placeholder': '例：ウォーターマーク、ちらつき、低解像度、ぼやけたキャラクター...',
  'create.sora.thinking': 'Soraが考えています...',
  'create.video.analyzing': '画像とプロンプトを分析中、AIが作成中...',
  'create.video.info': '長さ: {duration}秒 | 比率: {ratio}',
  'create.video.preview': '動画プレビュー',
  'create.video.result': '最終動画プレビュー',
  'create.video.empty': '生成された結果がここに表示されます',
  'create.download': '動画をダウンロード',
  'create.duration.format': '{duration}秒',
  'create.duration.4s': '4秒',
  'create.duration.8s': '8秒',
  'create.duration.15s': '15秒',
  'create.estimated.price': '見積もり: {price}',
  'create.model.select': 'モデルを選択',
  'create.model.loading': 'モデルを読み込み中...',
  'create.model.loadFailed': 'モデルリストの読み込みに失敗しました',
  'create.model.family.select': 'モデルファミリーを選択',
  'create.model.family.select.placeholder': 'モデルファミリーを選択してください',
  'create.model.family.loadFailed': 'モデルファミリーリストの読み込みに失敗しました',
  'create.style.select.placeholder': 'アートスタイルを選択してください（オプション、デフォルトはファミリーモデルを使用）',
  'create.model.style.loadFailed': 'スタイルモデルリストの読み込みに失敗しました',
  'create.model.description': 'モデル説明',
  'create.model.aspectResolution': 'アスペクト比解像度',
  'create.model.fps': 'フレームレート',
  'create.model.features': 'サポートされている機能',
  'create.model.feature.cameraMotion': 'カメラモーション',
  'create.model.feature.img2video': '画像から動画',
  'create.model.feature.videoEdit': '動画編集',
  'create.model.price.perSecond': '/秒',
  'create.model.detail': '詳細',
  'create.history.title': '生成履歴',
  'create.history.refresh': '更新',
  'create.history.empty': '生成履歴がありません',
  'create.history.total': '合計 {total} 件',
  'create.history.status.queued': 'キュー待ち',
  'create.history.status.processing': '処理中',
  'create.history.status.success': '成功',
  'create.history.status.failed': '失敗',
  'create.history.status.timeout': 'タイムアウト',
  'create.history.failed.noImage': '生成失敗',
  'create.history.failed.noVideo': '生成失敗',
  'create.history.downloadAll.start': '{count}枚の画像のダウンロードを開始',
  'create.history.downloadAll.tooltip': 'すべての{count}枚の画像をダウンロード',
  'create.history.download.tooltip': '画像をダウンロード',
  'create.history.detail.tooltip': '詳細を表示',
  'create.history.noPrompt': 'プロンプトなし',
  'create.history.deleteConfirm.title': '削除の確認',
  'create.history.deleteConfirm.content': 'このタスクを削除してもよろしいですか？この操作は元に戻せません。',
  'create.history.deleteSuccess': '削除しました',
  'create.history.deleteFailed': '削除に失敗しました',
  'create.taskDetail.title': 'タスク詳細',
  'create.taskDetail.loading': '読み込み中...',
  'create.taskDetail.loadFailed': 'タスク詳細の読み込みに失敗しました',
  'create.taskDetail.noData': 'データがありません',
  'create.taskDetail.basicInfo': '基本情報',
  'create.taskDetail.model': 'モデル',
  'create.taskDetail.taskType': 'タスクタイプ',
  'create.taskDetail.createTime': '作成時刻',
  'create.taskDetail.duration': '生成時間',
  'create.taskDetail.prompt': 'プロンプト',
  'create.taskDetail.error': 'エラーメッセージ',
  'create.taskDetail.outputFiles': '出力ファイル',
  'create.taskDetail.downloadAll': 'すべてダウンロード',
  'create.taskDetail.downloadAll.start': '{count}枚の画像のダウンロードを開始',
  'create.taskDetail.modelInfo': 'モデル情報',
  'create.taskDetail.defaultResolution': 'デフォルト解像度',
  'create.taskDetail.maxResolution': '最大解像度',
  'create.taskDetail.aspectRatios': 'サポートされているアスペクト比',
  'create.taskDetail.formats': 'サポートされている形式',
  'create.taskDetail.prompt.copied': 'プロンプトをコピーしました',
  'create.taskDetail.liked': 'いいね済み',
  'create.taskDetail.like': 'いいね',
  'create.taskDetail.collected': '保存済み',
  'create.taskDetail.collect': '保存',
  'create.taskDetail.linkCopied': 'リンクをコピーしました',
  'create.taskDetail.share': '共有',
  'create.taskDetail.outputs': '出力',
  'create.taskDetail.preview': 'プレビュー',
  'create.taskDetail.download': 'ダウンロード',
  'create.taskDetail.generationFailed': '生成失敗',
  'create.taskDetail.generating': '生成中...',
  'create.taskDetail.promptLabel': 'プロンプト',
  'create.taskDetail.copy': 'コピー',
  'create.taskDetail.executionStats': '実行統計',
  'create.taskDetail.creditsCost': 'クレジットコスト',
  'create.taskDetail.modelSpecs': 'モデル仕様',
  'create.taskDetail.capabilities': '機能',
  'create.taskDetail.supportedRatios': 'サポートされているアスペクト比',
  'create.taskDetail.dataError': 'データエラー',
  'create.taskDetail.more': 'もっと見る',
  'create.taskDetail.downloading': 'ダウンロード中...',
  'create.taskDetail.points': 'ポイント',
  'create.taskDetail.seconds': '秒',
  'create.taskDetail.status.success': '成功',
  'create.taskDetail.status.failed': '失敗',
  'create.taskDetail.status.processing': '処理中',
  'create.taskDetail.status.queued': '待機中',
  'create.taskDetail.status.generating': '生成中',
  'create.taskDetail.durationLabel': '所要時間',
  'create.taskDetail.taskParams': 'タスクパラメータ',
  'create.taskDetail.aspectRatio': 'アスペクト比',
  'create.taskDetail.inputType': '入力タイプ',
  'create.taskDetail.modelCode': 'モデルコード',
  'create.taskDetail.regenerate': '再生成',
  'create.taskDetail.feature.developing': '機能開発中',
  'create.taskDetail.result': '生成結果',
  'create.taskDetail.copyPrompt': 'プロンプトをコピー',
  'create.taskDetail.imageDimensions': 'サイズ',
  'create.taskDetail.fileSize': 'ファイルサイズ',
  'create.taskDetail.loadingImageInfo': '画像情報を読み込み中...',
  'create.video.generate.cancelled.polling': 'タスクポーリングをキャンセル',
  'create.video.generate.queued': '動画生成タスクを送信しました。キューに入っています...',
  'create.video.generate.noUrl': '動画生成が完了しましたが、動画URLが見つかりませんでした',
  'create.video.status.checkFailed': 'タスクステータスの確認に失敗しました',
  'create.video.generate.processing': '動画生成タスクを送信しました。処理中...',
  'create.video.taskQueue': 'タスクキュー',
  'create.video.polling': '動画を生成中です。お待ちください...',
  'create.video.ratio.invalid': 'モデルがサポートする動画アスペクト比を選択してください',
  'create.waitingTask.queue': 'タスクキュー',
  'create.waitingTask.empty': '進行中のタスクはありません',
  'create.waitingTask.generating': '生成中...',
  'create.waitingTask.queued': '待機中',
  'create.waitingTask.cancel': 'タスクをキャンセル',
  // HistorySection 新規国際化
  'create.history.copyPrompt': 'プロンプトをコピー',
  'create.history.download': 'ダウンロード',
  'create.history.delete': '削除',
  'create.history.generating': '生成中...',
  'create.history.generationFailed': '生成失敗',
  'create.history.noPreview': 'プレビューなし',
  // ImageToVideo 新規国際化
  'create.i2v.fileType.error': '画像ファイルを選択してください',
  'create.i2v.fileSize.error': '画像ファイルサイズは10MBを超えることはできません',
  'create.i2v.imageSize.error': '画像の高さは少なくとも {minHeight}px 必要です。現在の画像サイズは {width}x{height}px です',
  'create.i2v.fileRead.error': '画像の読み込みに失敗しました',
  'create.i2v.replaceImage': '画像を置き換え',
  'create.i2v.upload.supportedFormats': 'JPG、PNG、WebP、JFIFをサポート',
  'create.i2v.upload.required': '参照画像をアップロードしてください',
  'create.i2v.upload': '参照画像をアップロード (開始フレーム)',
  'create.i2v.upload.click': 'クリックまたはドラッグしてアップロード',
  'create.i2v.prompt.required': '動きのガイダンス説明を入力してください',
  'create.i2v.uploading.image': 'クラウドに画像をアップロード中...',
  'create.i2v.upload.success': '画像のアップロードに成功しました',
  'create.i2v.upload.failed': '画像のアップロードに失敗しました。再試行してください',
  'create.i2v.original': '元画像（開始フレーム）',
  'create.i2v.result': '生成比較',
  'create.i2v.empty': '生成結果と元画像の比較がここに表示されます',
  'create.generate.i2v': '動画生成を開始',
  'create.prompt.i2v.placeholder': '例：画像内の人物を歩かせ、背景の葉を風に揺らす...',
  'create.prompt.enhance.tooltip': 'AIでプロンプトを豊かにし、説明をより詳細で生き生きとさせます',
  'create.prompt.enhance': 'AI強化',
  'create.prompt.enhance.empty': 'まず基本プロンプトを入力してください',
  'create.prompt.enhance.success': 'プロンプトの強化に成功しました！',
  'create.prompt.enhance.empty.result': '強化されたプロンプトが生成されませんでした。再試行してください',
  'create.prompt.enhance.error': 'プロンプトの強化に失敗しました。再試行してください',
  'create.prompt.version.history': 'バージョン履歴',
  'create.prompt.version.history.tooltip': 'プロンプトバージョン履歴を表示',
  // TaskDetailModal 新規国際化
  'create.taskDetail.unnamedTask': '名前のないタスク',
  'create.taskDetail.prompt.title': 'プロンプト',
  'create.taskDetail.tokenCost': 'トークン消費',
  'create.taskDetail.publish': 'コミュニティに公開',
  'create.taskDetail.selectCover': 'カバーを選択',
  'create.taskDetail.selectChannel': 'チャンネルを選択',
  'create.taskDetail.selectChallenge': 'チャレンジを選択',
  'create.taskDetail.publishSuccess': '公開成功',
  'create.taskDetail.loadChannelsFailed': 'チャンネルの読み込みに失敗しました',
  'create.taskDetail.loadChallengesFailed': 'チャレンジの読み込みに失敗しました',
  'create.taskDetail.publishFailed': '公開に失敗しました',
  'create.taskDetail.daysLeft': 'あと {days} 日',
  // ModelDetailModal 新規国際化
  'create.model.capability.t2v': 'T2V（テキストから動画）',
  'create.model.capability.img2video': '画像から動画',
  'create.model.capability.videoEdit': '動画編集',
  'create.model.capability.characterConsistency': 'キャラクター一貫性',
  'create.model.capability.reference': '参照',
  'create.model.capability.cameraMotion': 'カメラモーション',
  'create.model.aspectRatios': 'アスペクト比',
  'create.model.resolution': '解像度',
  'create.model.resolution.default': 'デフォルト',
  'create.model.resolution.max': '最大',
  'create.model.duration': '長さ',
  'create.model.formats': 'フォーマット',
  'create.model.like': 'いいね',
  'create.model.liked': 'いいね済み',
  'create.model.unliked': 'いいねを取り消しました',
  'create.model.favorite': 'お気に入り',
  'create.model.favorited': 'お気に入りに追加しました',
  'create.model.unfavorited': 'お気に入りから削除しました',
  'create.model.share': '共有',
  'create.model.linkCopied': 'リンクをコピーしました',
  'create.model.capabilities': '機能',
  'create.model.free': '無料',
  'create.model.tokenCost.display': '{count} token',
  // その他の新規キー
  'create.aspectRatio.portrait': '縦向き',
  'create.aspectRatio.landscape': '横向き',
  'create.video.ratio.placeholder': '動画のアスペクト比を選択してください',
  'create.video.format.placeholder': '出力フォーマットを選択してください',
  'create.video.style': '動画スタイル',
  'create.video.style.tooltip': '動画生成スタイルを選択',
  'create.video.style.placeholder': '動画スタイルを選択してください',
  'create.video.quality': '動画品質',
  'create.video.quality.tooltip': '動画生成品質を選択',
  'create.video.quality.placeholder': '動画品質を選択してください',
  'create.duration.select.placeholder': '動画の長さを選択してください',
  'create.model.select.placeholder': 'まずモデルを選択してください',
  'video.not.supported': 'お使いのブラウザは動画再生をサポートしていません。',
  // UnderDevelopment 国際化
  'underDevelopment.comingSoon': '近日公開',
  'underDevelopment.title': '機能開発中',
  'underDevelopment.subtitle': 'この機能の開発に取り組んでいます。しばらくお待ちください！',
  'underDevelopment.backHome': 'ホームに戻る',
  'underDevelopment.goBack': '戻る',
  // UserMenu 国際化
  'userMenu.email.notBound': 'メール未登録',
  'userMenu.status.verified': '認証済み',
  'userMenu.status.guest': 'ゲスト',
  'userMenu.level': 'レベル',
  'userMenu.member.vip1': '一般メンバー',
  'userMenu.member.vip2': 'シルバーメンバー',
  'userMenu.member.vip3': 'ゴールドメンバー',
  'userMenu.member.vip4': 'ダイヤモンドメンバー',
  'userMenu.member.vip5': '最高級メンバー',
  'userMenu.recharge': 'チャージ',
  'userMenu.community': 'コミュニティ',
  'userMenu.group.account': 'アカウント設定',
  'userMenu.group.assets': '資産と注文',
  'userMenu.group.workspace': 'ワークスペース',
  'userMenu.group.support': 'サポート',
  'userMenu.item.profile': 'プロフィール',
  'userMenu.item.settings': '設定',
  'userMenu.item.security': 'セキュリティ',
  'userMenu.item.privacy': 'プライバシー',
  'userMenu.item.wallet': 'ウォレット',
  'userMenu.item.subscription': 'サブスクリプション',
  'userMenu.item.orders': '注文履歴',
  'userMenu.item.works': 'マイ作品',
  'userMenu.item.notifications': '通知',
  'userMenu.item.help': 'ヘルプセンター',
  'userMenu.item.invite': '友達を招待',
  'userMenu.item.feedback': 'フィードバック',
  'userMenu.item.about': '私たちについて',
  'userMenu.logout': 'ログアウト',
  // Achievement System 国際化
  'achievement.category.all': 'すべて',
  'achievement.category.basic': '基本',
  'achievement.category.creation': '創作',
  'achievement.category.payment': 'チャージ',
  'achievement.category.membership': 'メンバー',
  'achievement.category.level': 'レベル',
  'achievement.category.social': 'ソーシャル',
  'achievement.category.works': '作品',
  'achievement.level.current': '現在のレベル：{level}',
  'achievement.stats.unlocked': 'アンロック済み',
  'achievement.stats.locked': 'ロック済み',
  'achievement.stats.progress': '進捗',
  'achievement.stats.exp': '現在の経験値',
  // Recharge Agreement 国際化
  'rechargeAgreement.back': '戻る',
  'rechargeAgreement.title': 'チャージサービス規約',
  'rechargeAgreement.lastUpdated': '最終更新：',
  'rechargeAgreement.goRecharge': 'チャージへ',
  'rechargeAgreement.section1.title': '一、規約範囲',
  'rechargeAgreement.section1.content1': '本規約は、お客様とプラットフォーム間のチャージサービスに関する法的規約です。チャージサービスをご利用前に、本規約の全内容をよくお読みください。本規約のいかなる内容にも同意しない場合、または関連条項の意味を正確に理解できない場合は、チャージ操作を行わないでください。',
  'rechargeAgreement.section1.content2': '「同意」をクリックするか、チャージ操作を行うことで、本規約の全内容を十分に読み、理解し、同意したものとみなされます。',
  'rechargeAgreement.section2.title': '二、チャージ説明',
  'rechargeAgreement.section2.subtitle1': '2.1 チャージ方法',
  'rechargeAgreement.section2.content1': 'プラットフォームは以下のチャージ方法をサポートしています：',
  'rechargeAgreement.section2.method1': 'アリペイ',
  'rechargeAgreement.section2.method2': 'WeChat Pay',
  'rechargeAgreement.section2.method3': '銀行カード（銀聯、Visa、MasterCard）',
  'rechargeAgreement.section2.method4': 'USDT暗号通貨（ERC20/TRC20）',
  'rechargeAgreement.section2.subtitle2': '2.2 チャージ通貨',
  'rechargeAgreement.section2.content2': 'プラットフォームは以下の通貨でのチャージをサポートしています：人民元（CNY）、米ドル（USD）、USDT。異なる通貨間で為替レート変換が行われる場合があり、具体的な為替レートはチャージ時のリアルタイム為替レートに準拠します。',
  'rechargeAgreement.section2.subtitle3': '2.3 チャージ制限',
  'rechargeAgreement.section2.limit1': '1回の最低チャージ金額：1元（または他の通貨の等価額）',
  'rechargeAgreement.section2.limit2': '1回の最高チャージ金額：50,000元（または他の通貨の等価額）',
  'rechargeAgreement.section2.limit3': '1日の累計チャージ制限：100,000元（または他の通貨の等価額）',
  'rechargeAgreement.section2.note': '注意：チャージ制限は、支払い方法、アカウントレベルなどの要因により異なる場合があります。詳細はチャージページに表示されます。',
  'rechargeAgreement.section3.title': '三、チャージ到着',
  'rechargeAgreement.section3.subtitle1': '3.1 到着時間',
  'rechargeAgreement.section3.time1': 'アリペイ、WeChat Pay：リアルタイム到着',
  'rechargeAgreement.section3.time2': '銀行カード：1-3営業日で到着',
  'rechargeAgreement.section3.time3': 'USDT：ブロックチェーンの確認時間に応じて、通常10-30分で到着',
  'rechargeAgreement.section3.subtitle2': '3.2 異常処理',
  'rechargeAgreement.section3.content1': 'チャージ後、到着が遅い場合は、支払い証明を保管し、すぐにカスタマーサービスに連絡してください。プラットフォームは確認後、できるだけ早くチャージの問題を処理します。',
  'rechargeAgreement.section4.title': '四、返金ポリシー',
  'rechargeAgreement.section4.important': '重要：チャージ成功後、アカウント残高は直接返金をサポートしていません。残高はプラットフォーム内のサービス消費にのみ使用できます。',
  'rechargeAgreement.section4.subtitle1': '4.1 返金条件',
  'rechargeAgreement.section4.content1': '以下の場合、返金を申請できます：',
  'rechargeAgreement.section4.refund1': 'プラットフォームシステムの障害による重複チャージ',
  'rechargeAgreement.section4.refund2': 'プラットフォームの理由によりサービスが正常に使用できず、アカウント残高が消費されていない場合',
  'rechargeAgreement.section4.refund3': 'プラットフォームが審査により同意したその他の特別な状況',
  'rechargeAgreement.section4.subtitle2': '4.2 返金プロセス',
  'rechargeAgreement.section4.process1': '返金申請を提出し、返金理由を説明',
  'rechargeAgreement.section4.process2': 'プラットフォーム審査（通常3-7営業日）',
  'rechargeAgreement.section4.process3': '承認後、返金は元の支払いアカウントに返されます',
  'rechargeAgreement.section5.title': '五、アカウントセキュリティ',
  'rechargeAgreement.section5.content1': 'お客様はアカウント情報とパスワードを適切に保管する責任があります。お客様自身の理由によりアカウントが盗用されたりパスワードが漏洩したりした場合の損失について、プラットフォームは責任を負いません。',
  'rechargeAgreement.section5.content2': 'アカウントに異常を発見した場合は、すぐにカスタマーサービスに連絡し、パスワードを変更してください。プラットフォームは関連する問題の処理を支援します。',
  'rechargeAgreement.section6.title': '六、免責事項',
  'rechargeAgreement.section6.disclaimer1': '不可抗力（自然災害、戦争、政府行為など）によるサービス中断について、プラットフォームは責任を負いません',
  'rechargeAgreement.section6.disclaimer2': '第三者支払いプラットフォームの障害によるチャージの問題について、プラットフォームは処理を支援しますが、直接的な責任は負いません',
  'rechargeAgreement.section6.disclaimer3': 'お客様が本規約または関連する法律・規制に違反したことによる損失は、お客様自身が負担します',
  'rechargeAgreement.section7.title': '七、規約変更',
  'rechargeAgreement.section7.content1': 'プラットフォームは、事業発展の必要性に応じて本規約を変更する権利を有します。規約変更後、プラットフォームの目立つ場所に公示されます。お客様がチャージサービスを引き続き使用する場合、変更後の規約を受け入れたものとみなされます。',
  'rechargeAgreement.section8.title': '八、連絡先',
  'rechargeAgreement.section8.content1': '本規約についてご質問がある場合、または返金申請、チャージ問題の処理が必要な場合は、以下の方法でお問い合わせください：',
  'rechargeAgreement.section8.contact1': 'カスタマーサービスメール：support@example.com',
  'rechargeAgreement.section8.contact2': 'オンラインカスタマーサービス：平日9:00-18:00',
  'rechargeAgreement.section8.contact3': 'ヘルプセンター：よくある質問を閲覧',
  // プロフィール国際化
  'profile.editProfile': 'プロフィール編集',
  'profile.creditScore': '信用スコア',
  'profile.level': 'レベル',
  'profile.balance': '残高',
  'profile.tab.basic': '基本情報',
  'profile.tab.account': 'アカウント資産',
  'profile.section.personal': '個人情報',
  'profile.section.contact': '連絡先',
  'profile.section.wallet': 'USDTウォレット',
  'profile.label.username': 'ユーザー名',
  'profile.label.realName': '本名',
  'profile.label.accountStatus': 'アカウント状態',
  'profile.label.phone': '電話番号',
  'profile.label.email': 'メールアドレス',
  'profile.label.registerTime': '登録時間',
  'profile.label.availableBalance': '利用可能残高',
  'profile.label.frozenAmount': '凍結金額',
  'profile.value.notVerified': '未認証',
  'profile.value.notBound': '未登録',
  'profile.value.noAddress': 'TRC20アドレスなし',
  'profile.value.noDescription': 'この人は怠け者で、何も書いていません',
  'profile.status.normal': '正常',
  'profile.status.disabled': '無効',
  'profile.tooltip.verified': '本人確認済み',
  'profile.tooltip.unverified': '本人確認する',
  'profile.banner.construction': 'このページは現在構築中です...',
  'profile.modal.title': 'プロフィール編集',
  'profile.modal.cancel': 'キャンセル',
  'profile.modal.save': '変更を保存',
  'profile.modal.avatarSection': 'アバター設定',
  'profile.modal.basicSection': '基本情報',
  'profile.modal.contactSection': '連絡先情報',
  'profile.modal.changeAvatar': 'アバター変更',
  'profile.modal.avatarHint': 'JPG、PNG形式をサポート、最大2MB',
  'profile.modal.nickname': 'ニックネーム',
  'profile.modal.nicknamePlaceholder': 'ニックネームを入力してください',
  'profile.modal.description': '自己紹介',
  'profile.modal.descriptionPlaceholder': '一言で自己紹介...',
  'profile.modal.phone': '電話番号',
  'profile.modal.email': 'メール',
  'profile.message.avatarSizeLimit': '画像サイズは2MBを超えることはできません',
  'profile.message.avatarUploadSuccess': 'アバターのアップロードに成功しました',
  'profile.message.saveSuccess': '保存に成功しました',
  'profile.message.saveFailed': '保存に失敗しました',
  'profile.message.uploadAvatarFailed': 'アバターのアップロードに失敗しました',
  'profile.message.operationFailed': '操作に失敗しました',
  'privacyPreferences.title': 'プライバシー設定',
  'privacyPreferences.description': 'プライバシー設定を管理し、データの収集と使用方法を制御します',
  'privacyPreferences.back': '戻る',
  'privacyPreferences.save': '設定を保存',
  'privacyPreferences.saveSuccess': 'プライバシー設定が正常に保存されました',
  'privacyPreferences.saveError': '保存に失敗しました。後でもう一度お試しください',
  'privacyPreferences.required': '必須',
  'privacyPreferences.info': 'プライバシー設定はローカルに保存され、次回訪問時に自動的に適用されます。ログインすると、設定をクラウドに同期できます。',
  'privacyPreferences.info.loggedIn': 'プライバシー設定はアカウントに保存され、すべてのデバイスで同期されます。いつでもこのページに戻って設定を変更できます。',
  'cookieBanner.message': 'ログイン、テーマおよび基本機能のためにCookieとローカルストレージを使用しています。続行すると、プライバシーポリシーに従ってこれらに同意したことになります。',
  'cookieBanner.acceptAll': 'すべて同意',
  'cookieBanner.essentialOnly': '必須のみ',
  'cookieBanner.settings': '設定',
  'privacyPreferences.cookies.title': 'Cookie設定',
  'privacyPreferences.cookies.description': 'Cookieはより良いサービス体験を提供するのに役立ちます。特定のタイプのCookieを受け入れるか拒否するかを選択できます。',
  'privacyPreferences.cookies.essential': '必須Cookie',
  'privacyPreferences.cookies.essential.desc': 'これらのCookieは、ウェブサイトが正常に機能するために必要であり、無効にすることはできません。通常、セキュリティ、ログイン、基本機能に使用されます。',
  'privacyPreferences.cookies.functional': '機能Cookie',
  'privacyPreferences.cookies.functional.desc': 'これらのCookieにより、ウェブサイトはお客様の選択を記憶し、強化された機能とパーソナライズされた体験を提供できます。',
  'privacyPreferences.cookies.analytics': '分析Cookie',
  'privacyPreferences.cookies.analytics.desc': 'これらのCookieは、訪問者がウェブサイトをどのように使用しているかを理解し、サービスを改善するのに役立ちます。',
  'privacyPreferences.cookies.marketing': 'マーケティングCookie',
  'privacyPreferences.cookies.marketing.desc': 'これらのCookieは、お客様の閲覧活動を追跡して、関連する広告やコンテンツを表示するために使用されます。',
  'privacyPreferences.data.title': 'データ収集設定',
  'privacyPreferences.data.description': 'サービス体験を改善するためにデータを収集および使用する方法を制御します。',
  'privacyPreferences.data.collection': 'データ収集',
  'privacyPreferences.data.collection.desc': 'サービスを提供および改善するために必要な使用データを収集することを許可します。',
  'privacyPreferences.data.analytics': 'データ分析',
  'privacyPreferences.data.analytics.desc': 'サービスパフォーマンスとユーザー体験を最適化するために、使用パターンを分析することを許可します。',
  'privacyPreferences.data.personalization': 'パーソナライゼーション',
  'privacyPreferences.data.personalization.desc': 'お客様の好みと使用習慣に基づいて、パーソナライズされたコンテンツと推奨を提供することを許可します。',
  'privacyPreferences.marketing.title': 'マーケティング設定',
  'privacyPreferences.marketing.description': '受け取りたいマーケティング情報のタイプを選択します。',
  'privacyPreferences.marketing.emails': 'マーケティングメール',
  'privacyPreferences.marketing.emails.desc': '製品更新、プロモーション、特別オファーに関するメール通知を受け取ります。',
  'privacyPreferences.marketing.sms': 'マーケティングSMS',
  'privacyPreferences.marketing.sms.desc': '重要な更新とプロモーションに関するSMS通知を受け取ります。',
  'privacyPreferences.marketing.push': 'プッシュ通知',
  'privacyPreferences.marketing.push.desc': '製品更新や重要なメッセージを含むブラウザプッシュ通知を受け取ります。',
  'privacyPreferences.thirdParty.title': '第三者データ共有',
  'privacyPreferences.thirdParty.description': '第三者サービスプロバイダーとデータを共有することを許可するかどうかを制御します。',
  'privacyPreferences.thirdParty.sharing': '第三者データ共有',
  'privacyPreferences.thirdParty.sharing.desc': 'サービスを改善するために、信頼できる第三者サービスプロバイダーと匿名化された使用データを共有することを許可します。',
  'works.title': '私の作品',
  'works.description': '生成したすべての作品を管理および表示',
  'works.refresh': '更新',
  'works.stats.total': '全作品',
  'works.stats.images': '画像',
  'works.stats.videos': '動画',
  'works.stats.audios': '音声',
  'works.stats.favorites': 'お気に入り',
  'works.search.placeholder': '作品を検索...',
  'works.filter.all': 'すべてのタイプ',
  'works.filter.image': '画像',
  'works.filter.video': '動画',
  'works.filter.audio': '音声',
  'works.date.start': '開始日',
  'works.date.end': '終了日',
  'works.sort.date': '日付順',
  'works.sort.name': '名前順',
  'works.sort.size': 'サイズ順',
  'works.sort.asc': '昇順',
  'works.sort.desc': '降順',
  'works.view.grid': 'グリッド',
  'works.view.list': 'リスト',
  'works.type.video': '動画',
  'works.type.image': '画像',
  'works.type.audio': '音声',
  'works.preview': 'プレビュー',
  'works.download': 'ダウンロード',
  'works.share': '共有',
  'works.delete': '削除',
  'works.deleteConfirm': 'この作品を削除してもよろしいですか？',
  'works.loadError': '作品の読み込みに失敗しました。後でもう一度お試しください',
  'works.favoriteUpdated': 'お気に入りステータスが更新されました',
  'works.favoriteError': 'お気に入りの更新に失敗しました',
  'works.downloading': 'ダウンロード中...',
  'works.sharing': '共有リンクを生成中...',
  'works.deleted': '作品が削除されました',
  'works.deleteError': '削除に失敗しました。後でもう一度お試しください',
  'works.empty.title': '作品がありません',
  'works.empty.description': '最初の作品を作成しましょう！',
  'works.empty.action': '作成する',
  'works.pagination.total': '合計 {total} 件、{start}-{end} 件を表示',
  
  // プライバシーポリシー
  'privacyPolicy.title': 'プライバシーポリシー',
  'privacyPolicy.lastUpdated': '最終更新日：{date}',
  'privacyPolicy.intro1': '本プライバシーポリシーは、AIMATEX プラットフォーム（以下「当社」または「本プラットフォーム」）が、お客様が当社のサービスをご利用になる際に、お客様の個人情報をどのように収集、使用、保存、保護するか、およびお客様のプライバシー権利について説明しています。当社はお客様のプライバシー保護を非常に重視しており、本プライバシーポリシーをよくお読みください。',
  'privacyPolicy.intro2': '当社のサービスを使用することにより、お客様は本プライバシーポリシーに同意したものとみなされます。本プライバシーポリシーのいかなる内容にも同意しない場合は、当社のサービスを使用しないでください。',
  'privacyPolicy.section1.title': '一、当社が収集する情報',
  'privacyPolicy.section1.1.title': '1.1 お客様が提供する情報',
  'privacyPolicy.section1.1.intro': '本サービスを使用する際、お客様は以下の情報を提供する必要がある場合があります：',
  'privacyPolicy.section1.1.item1.label': 'アカウント情報',
  'privacyPolicy.section1.1.item1.desc': 'ユーザー名、メールアドレス、パスワード、電話番号など',
  'privacyPolicy.section1.1.item2.label': 'プロフィール情報',
  'privacyPolicy.section1.1.item2.desc': 'アバター、ニックネーム、自己紹介など（オプション）',
  'privacyPolicy.section1.1.item3.label': '支払い情報',
  'privacyPolicy.section1.1.item3.desc': '支払い方法、請求先住所など（支払い処理用）',
  'privacyPolicy.section1.1.item4.label': '生成コンテンツ',
  'privacyPolicy.section1.1.item4.desc': 'アップロードしたテキストプロンプト、参照画像、生成された動画、音楽、画像、3Dモデルなど',
  'privacyPolicy.section1.2.title': '1.2 自動収集される情報',
  'privacyPolicy.section1.2.intro': '本サービスを使用する際、当社は以下の情報を自動的に収集する場合があります：',
  'privacyPolicy.section1.2.item1.label': 'デバイス情報',
  'privacyPolicy.section1.2.item1.desc': 'デバイスタイプ、オペレーティングシステム、ブラウザタイプとバージョン、デバイス識別子など',
  'privacyPolicy.section1.2.item2.label': '使用データ',
  'privacyPolicy.section1.2.item2.desc': 'アクセス時間、アクセスページ、使用機能、操作記録など',
  'privacyPolicy.section1.2.item3.label': 'ネットワーク情報',
  'privacyPolicy.section1.2.item3.desc': 'IPアドレス、ネットワークタイプ、ネットワーク事業者など',
  'privacyPolicy.section1.2.item4.label': 'ログ情報',
  'privacyPolicy.section1.2.item4.desc': 'エラーログ、パフォーマンスデータなど',
  'privacyPolicy.section1.3.title': '1.3 Cookie および類似技術',
  'privacyPolicy.section1.3.intro': '当社は Cookie および類似技術を以下の目的で使用します：',
  'privacyPolicy.section1.3.item1': 'ログイン状態の維持',
  'privacyPolicy.section1.3.item2': 'お客様の設定（言語、テーマなど）の記憶',
  'privacyPolicy.section1.3.item3': 'サービス使用状況の分析、サービス品質の向上',
  'privacyPolicy.section1.3.item4': 'パーソナライズされた体験の提供',
  'privacyPolicy.section1.3.note': 'ブラウザ設定で Cookie を拒否できますが、一部の機能の使用に影響する場合があります。',
  'privacyPolicy.section2.title': '二、情報の使用目的',
  'privacyPolicy.section2.intro': '当社はお客様の情報を以下の目的で収集・使用します：',
  'privacyPolicy.section2.item1.label': 'サービスの提供',
  'privacyPolicy.section2.item1.desc': 'コンテンツ生成リクエスト（動画、音楽、画像、3Dモデルなど）の処理、アカウントと作品の管理など',
  'privacyPolicy.section2.item2.label': 'サービスの改善',
  'privacyPolicy.section2.item2.desc': '使用状況の分析、サービスパフォーマンスとユーザー体験の最適化',
  'privacyPolicy.section2.item3.label': 'アカウント管理',
  'privacyPolicy.section2.item3.desc': '本人確認、支払い処理、通知の送信など',
  'privacyPolicy.section2.item4.label': 'セキュリティ',
  'privacyPolicy.section2.item4.desc': '詐欺、悪用、セキュリティ脅威の検出と防止など',
  'privacyPolicy.section2.item5.label': 'カスタマーサポート',
  'privacyPolicy.section2.item5.desc': 'お問い合わせへの対応、苦情とフィードバックの処理など',
  'privacyPolicy.section2.item6.label': '法的遵守',
  'privacyPolicy.section2.item6.desc': '法的要件の遵守、法執行機関の調査への協力など',
  'privacyPolicy.section3.title': '三、情報の共有と開示',
  'privacyPolicy.section3.1.title': '3.1 当社はお客様の個人情報を販売しません',
  'privacyPolicy.section3.1.content': '当社は第三者に個人情報を販売、賃貸、またはその他の方法で取引することはありません。',
  'privacyPolicy.section3.2.title': '3.2 サービスプロバイダー',
  'privacyPolicy.section3.2.intro': '当社は以下のタイプのサービスプロバイダーと情報を共有する場合があります：',
  'privacyPolicy.section3.2.item1.label': 'クラウドサービスプロバイダー',
  'privacyPolicy.section3.2.item1.desc': 'データの保存と処理用',
  'privacyPolicy.section3.2.item2.label': '支払いサービスプロバイダー',
  'privacyPolicy.section3.2.item2.desc': '支払い取引の処理用',
  'privacyPolicy.section3.2.item3.label': '分析サービスプロバイダー',
  'privacyPolicy.section3.2.item3.desc': 'サービス使用状況の分析用',
  'privacyPolicy.section3.2.item4.label': 'カスタマーサポートサービスプロバイダー',
  'privacyPolicy.section3.2.item4.desc': 'カスタマーサポートの提供用',
  'privacyPolicy.section3.2.note': 'これらのサービスプロバイダーは、当社にサービスを提供する目的でのみ情報を使用でき、他の目的には使用できません。',
  'privacyPolicy.section3.3.title': '3.3 法的要件',
  'privacyPolicy.section3.3.intro': '以下の状況では、当社はお客様の情報を開示する場合があります：',
  'privacyPolicy.section3.3.item1': '法律、規制、裁判所命令、または政府の要件を遵守するため',
  'privacyPolicy.section3.3.item2': '当社の権利、財産、または安全を保護するため',
  'privacyPolicy.section3.3.item3': '違法行為の防止または調査のため',
  'privacyPolicy.section3.3.item4': 'ユーザーまたは公衆の安全を保護するため',
  'privacyPolicy.section3.4.title': '3.4 事業譲渡',
  'privacyPolicy.section3.4.content': '合併、買収、または資産譲渡が発生した場合、お客様の情報が移転される可能性があります。移転前に通知いたします。',
  'privacyPolicy.section4.title': '四、情報の保存とセキュリティ',
  'privacyPolicy.section4.1.title': '4.1 保存場所',
  'privacyPolicy.section4.1.content': 'お客様の情報は、中華人民共和国国内または国外のサーバーに保存される場合があります。当社は情報のセキュリティを確保するための適切な措置を講じます。',
  'privacyPolicy.section4.2.title': '4.2 保存期間',
  'privacyPolicy.section4.2.intro': '当社は必要な期間のみお客様の情報を保持します：',
  'privacyPolicy.section4.2.item1': 'アカウント情報：アカウント存続期間中および削除後一定期間',
  'privacyPolicy.section4.2.item2': '生成コンテンツ：お客様の設定または法的要件に従って保持',
  'privacyPolicy.section4.2.item3': '使用データ：通常、分析とサービス改善のために短い期間保持',
  'privacyPolicy.section4.3.title': '4.3 セキュリティ対策',
  'privacyPolicy.section4.3.intro': '当社はお客様の情報を保護するために以下のセキュリティ対策を講じています：',
  'privacyPolicy.section4.3.item1': '暗号化された送信と保存',
  'privacyPolicy.section4.3.item2': 'アクセス制御と認証',
  'privacyPolicy.section4.3.item3': '定期的なセキュリティ監査と脆弱性スキャン',
  'privacyPolicy.section4.3.item4': '従業員のトレーニングと機密保持契約',
  'privacyPolicy.section4.3.note': 'セキュリティ対策が100%安全であることはありません。情報の絶対的なセキュリティを保証することはできません。',
  'privacyPolicy.section5.title': '五、お客様の権利',
  'privacyPolicy.section5.intro': '適用される法律・規制に基づき、お客様は以下の権利を有します：',
  'privacyPolicy.section5.item1.label': 'アクセス権',
  'privacyPolicy.section5.item1.desc': '当社が保持するお客様の個人情報を閲覧する',
  'privacyPolicy.section5.item2.label': '訂正権',
  'privacyPolicy.section5.item2.desc': '不正確または不完全な情報を訂正する',
  'privacyPolicy.section5.item3.label': '削除権',
  'privacyPolicy.section5.item3.desc': 'お客様の個人情報の削除を要求する（法律で保持が要求される場合を除く）',
  'privacyPolicy.section5.item4.label': '同意撤回権',
  'privacyPolicy.section5.item4.desc': '情報処理への同意を撤回する',
  'privacyPolicy.section5.item5.label': 'データポータビリティ権',
  'privacyPolicy.section5.item5.desc': 'お客様の個人情報のコピーを取得する',
  'privacyPolicy.section5.item6.label': '異議申立権',
  'privacyPolicy.section5.item6.desc': '特定の情報処理活動に異議を申し立てる',
  'privacyPolicy.section5.note': '上記の権利を行使するには、本プライバシーポリシーの末尾の連絡先を通じて当社にご連絡ください。',
  'privacyPolicy.section6.title': '六、未成年者の保護',
  'privacyPolicy.section6.content1': '本サービスは主に18歳以上のユーザーを対象としています。18歳未満の場合は、保護者の同意と指導の下で本サービスをご利用ください。',
  'privacyPolicy.section6.content2': '18歳未満のユーザーの個人情報を収集し、保護者の同意を得ていないことが判明した場合、当社は関連情報をできるだけ早く削除します。',
  'privacyPolicy.section7.title': '七、第三者リンク',
  'privacyPolicy.section7.content': '本サービスには、第三者ウェブサイトへのリンクが含まれる場合があります。当社はこれらの第三者ウェブサイトのプライバシー慣行について責任を負いません。これらのウェブサイトにアクセスする際は、そのプライバシーポリシーを確認してください。',
  'privacyPolicy.section8.title': '八、プライバシーポリシーの変更',
  'privacyPolicy.section8.content1': '当社は本プライバシーポリシーを随時更新する場合があります。重要な変更は、発効の少なくとも30日前に通知いたします。サービスの継続使用は、更新されたプライバシーポリシーに同意したことを意味します。',
  'privacyPolicy.section8.content2': '当社は本ページの上部で「最終更新日」を更新し、メールまたはアプリ内通知で重要な変更をお知らせします。',
  'privacyPolicy.section9.title': '九、お問い合わせ',
  'privacyPolicy.section9.intro': '本プライバシーポリシーに関するご質問、ご意見、または苦情がございましたら、以下の方法で当社にお問い合わせください：',
  'privacyPolicy.section9.email': 'メール：{email}',
  'privacyPolicy.section9.hours': 'カスタマーサポート時間：平日 9:00-18:00',
  'privacyPolicy.section9.response': '当社は合理的な時間内にお客様のリクエストに回答いたします。',
  
  // 利用規約
  'termsOfService.title': '利用規約',
  'termsOfService.lastUpdated': '最終更新日：{date}',
  'termsOfService.intro': '当社のサービスを使用する前に、本利用規約をよくお読みください。AIMATEX プラットフォーム（以下「本プラットフォーム」または「サービス」）にアクセスまたは使用することにより、お客様は本利用規約に拘束されることに同意したものとみなされます。本利用規約のいかなる部分にも同意しない場合は、当社のサービスを使用しないでください。',
  'termsOfService.section1.title': '一、定義と解釈',
  'termsOfService.section1.1.title': '1.1 定義',
  'termsOfService.section1.1.intro': '本利用規約において、文脈上別段の定めがない限り、以下の用語は以下の意味を有します：',
  'termsOfService.section1.1.item1.label': '「プラットフォーム」または「本プラットフォーム」',
  'termsOfService.section1.1.item1.desc': 'AIMATEX 動画生成サービスプラットフォームを指し、ウェブサイト、モバイルアプリケーション、および関連サービスを含みますが、これらに限定されません。',
  'termsOfService.section1.1.item2.label': '「当社」、「私たち」、「会社」',
  'termsOfService.section1.1.item2.desc': 'AIMATEX プラットフォームの運営者、すなわち ProTX Team を指します。',
  'termsOfService.section1.1.item3.label': '「お客様」、「ユーザー」',
  'termsOfService.section1.1.item3.desc': '本サービスにアクセスまたは使用する個人、会社、またはその他の法的実体を指します。',
  'termsOfService.section1.1.item4.label': '「サービス」',
  'termsOfService.section1.1.item4.desc': '本プラットフォームが提供するすべての機能とサービスを指し、AI動画、音楽、画像、3Dモデルなどの各種コンテンツ生成、モデル選択、作品管理、ユーザーアカウント管理などを含みますが、これらに限定されません。',
  'termsOfService.section1.1.item5.label': '「コンテンツ」',
  'termsOfService.section1.1.item5.desc': 'ユーザーが本プラットフォームを通じてアップロード、生成、作成、または共有するテキスト、画像、動画、音声などの材料を指します。',
  'termsOfService.section1.1.item6.label': '「生成コンテンツ」',
  'termsOfService.section1.1.item6.desc': 'ユーザーが本プラットフォームのAIモデルを使用して生成した動画、音楽、画像、3Dモデルなどの各種作品を指します。',
  'termsOfService.section1.1.item7.label': '「アカウント」',
  'termsOfService.section1.1.item7.desc': 'ユーザーが本プラットフォームに登録したユーザーアカウントを指します。',
  'termsOfService.section2.title': '二、サービスの説明',
  'termsOfService.section2.1.title': '2.1 サービス内容',
  'termsOfService.section2.1.intro': '本プラットフォームは、包括的なAIコンテンツ生成サービスを提供し、以下を含みますが、これらに限定されません：',
  'termsOfService.section2.1.item1': 'テキストからメディア生成（動画、音楽、画像、3Dモデルなど）（Text-to-Media）',
  'termsOfService.section2.1.item2': '画像からメディア生成（動画、3Dモデルなど）（Image-to-Media）',
  'termsOfService.section2.1.item3': '各種生成作品の管理と表示',
  'termsOfService.section2.1.item4': 'モデルの選択と管理',
  'termsOfService.section2.1.item5': 'ユーザーアカウントと個人センター',
  'termsOfService.section2.1.item6': 'サブスクリプションと支払いサービス',
  'termsOfService.section2.2.title': '2.2 サービスの変更',
  'termsOfService.section2.2.content': '当社は、事前通知なしに、いつでもサービスの一部または全部を変更、一時停止、または終了する権利を留保します。当社は、サービスの変更によるいかなる損失についても責任を負いません。',
  'termsOfService.section3.title': '三、ユーザーアカウント',
  'termsOfService.section3.1.title': '3.1 アカウント登録',
  'termsOfService.section3.1.intro': '本サービスを使用するには、アカウント登録が必要です。登録時、お客様は以下に同意したものとみなされます：',
  'termsOfService.section3.1.item1': '真実、正確、完全な登録情報を提供する',
  'termsOfService.section3.1.item2': '登録情報を適時に更新し、真実、正確、完全な状態を維持する',
  'termsOfService.section3.1.item3': 'アカウント下のすべての活動に責任を負う',
  'termsOfService.section3.1.item4': 'アカウントパスワードを適切に保管し、アカウントを他人に譲渡、販売、または貸与しない',
  'termsOfService.section3.2.title': '3.2 年齢制限',
  'termsOfService.section3.2.content': '本サービスを使用するには、18歳以上である必要があります。18歳未満の場合は、保護者の同意と指導の下で本サービスをご利用ください。',
  'termsOfService.section3.3.title': '3.3 アカウントセキュリティ',
  'termsOfService.section3.3.content': 'お客様はアカウントのセキュリティを維持する責任があります。アカウントが侵害された、またはセキュリティの脆弱性があることが判明した場合は、すぐに当社に通知してください。当社は、お客様がアカウント情報を適切に保護しなかったことによる損失について責任を負いません。',
  'termsOfService.section4.title': '四、使用規則',
  'termsOfService.section4.1.title': '4.1 禁止行為',
  'termsOfService.section4.1.intro': '本サービスを使用する際、お客様は以下を行ってはなりません：',
  'termsOfService.section4.1.item1': '違法、有害、脅迫的、侮辱的、嫌がらせ、誹謗中傷、低俗、わいせつ、他人のプライバシーまたは知的財産権を侵害するコンテンツを生成、アップロード、または共有する',
  'termsOfService.section4.1.item2': '虚偽の情報、誤解を招くコンテンツ、または悪意のあるコンテンツを生成または拡散する',
  'termsOfService.section4.1.item3': '本サービスを使用して商業詐欺、マネーロンダリング、またはその他の違法活動を行う',
  'termsOfService.section4.1.item4': '自動化ツール、クローラー、ウイルスなどを使用して、本プラットフォームの正常な動作を妨害または破壊する',
  'termsOfService.section4.1.item5': '本プラットフォームのシステム、データ、またはアカウントに無許可でアクセスする',
  'termsOfService.section4.1.item6': '本プラットフォームのいかなる部分も複製、変更、配布、販売、または賃貸する',
  'termsOfService.section4.1.item7': '本プラットフォームのいかなるソフトウェアもリバースエンジニアリング、逆コンパイル、または逆アセンブルする',
  'termsOfService.section4.2.title': '4.2 コンテンツ責任',
  'termsOfService.section4.2.content': 'お客様は、本プラットフォームを通じて生成、アップロード、または共有するすべてのコンテンツについて完全な責任を負います。当社はユーザー生成コンテンツを事前に審査しませんが、違反コンテンツをいつでも削除する権利を留保します。',
  'termsOfService.section5.title': '五、知的財産権',
  'termsOfService.section5.1.title': '5.1 プラットフォームの知的財産権',
  'termsOfService.section5.1.content': '本プラットフォームのすべての知的財産権（商標、特許、著作権、営業秘密などを含みますが、これらに限定されません）は、当社または関連権利者に帰属します。許可なく使用することはできません。',
  'termsOfService.section5.2.title': '5.2 ユーザー生成コンテンツ',
  'termsOfService.section5.2.content': 'お客様が本プラットフォームを通じて生成するコンテンツの知的財産権は、お客様に帰属します。ただし、お客様は当社に非独占的、世界的、無料、再許諾可能な権利を付与し、サービスを提供および改善するために、お客様のコンテンツを使用、表示、配布することを許可します。',
  'termsOfService.section5.3.title': '5.3 AIモデル',
  'termsOfService.section5.3.content': '本プラットフォームで使用されるAIモデル（Soraモデルを含む）の知的財産権は、その開発者に帰属します。お客様はこれらのモデルを複製、変更、または配布することはできません。',
  'termsOfService.section6.title': '六、有料サービス',
  'termsOfService.section6.1.title': '6.1 支払いモデル',
  'termsOfService.section6.1.content': '本プラットフォームは、サブスクリプションと従量課金の2つのモデルを提供します。具体的な価格と課金方法は、プラットフォームの公示に従います。',
  'termsOfService.section6.2.title': '6.2 支払い',
  'termsOfService.section6.2.content': 'お客様は、プラットフォームが公示する価格に従ってサービス料金を支払うことに同意します。すべての料金は、人民元またはプラットフォームがサポートするその他の通貨で計算されます。支払いが成功した後、法律で別段の定めがない限り、または当社が別途約束していない限り、料金は返金されません。',
  'termsOfService.section6.3.title': '6.3 返金ポリシー',
  'termsOfService.section6.3.content': '法律で別段の定めがない限り、または当社が別途約束していない限り、支払われた料金は返金されません。プラットフォームの理由によりサービスが正常に使用できない場合、当社は実際の状況に応じて返金または補償を提供します。',
  'termsOfService.section7.title': '七、サービスの可用性',
  'termsOfService.section7.1.title': '7.1 サービス中断',
  'termsOfService.section7.1.intro': '当社は、以下の理由によるサービス中断について責任を負いません：',
  'termsOfService.section7.1.item1': 'システムメンテナンス、アップグレード、または障害',
  'termsOfService.section7.1.item2': '不可抗力要因（自然災害、戦争、ストライキなど）',
  'termsOfService.section7.1.item3': '第三者サービスプロバイダーの問題',
  'termsOfService.section7.1.item4': 'ネットワーク障害またはユーザーデバイスの問題',
  'termsOfService.section7.2.title': '7.2 サービス保証',
  'termsOfService.section7.2.content': '当社はサービスの安定性と可用性を確保するよう努めますが、サービスが中断されない、エラーがない、または完全に安全であることを保証するものではありません。サービスは「現状のまま」および「利用可能」の基準で提供され、明示的または黙示的な保証は一切提供されません。',
  'termsOfService.section8.title': '八、プライバシー保護',
  'termsOfService.section8.content': '当社はお客様のプライバシー保護を重視しています。当社がお客様の個人情報をどのように収集、使用、保護するかについては、当社の「プライバシーポリシー」を参照してください。本サービスを使用することにより、お客様は当社のプライバシーポリシーに同意したものとみなされます。',
  'termsOfService.section9.title': '九、責任の制限',
  'termsOfService.section9.1.title': '9.1 責任の範囲',
  'termsOfService.section9.1.intro': '法律で許可される最大限の範囲で、当社は本サービスの使用または使用不能により生じたいかなる直接的、間接的、偶発的、特別、または結果的損害についても責任を負いません。これには以下が含まれますが、これらに限定されません：',
  'termsOfService.section9.1.item1': '利益損失、データ損失、またはその他の経済的損失',
  'termsOfService.section9.1.item2': '事業中断',
  'termsOfService.section9.1.item3': '人身傷害または財産損失',
  'termsOfService.section9.1.item4': 'プライバシー侵害',
  'termsOfService.section9.2.title': '9.2 責任の上限',
  'termsOfService.section9.2.content': '当社の総責任は、お客様が過去12か月間に本サービスを通じて実際に支払った料金の合計額、または100米ドル（いずれか高い方）を超えません。',
  'termsOfService.section10.title': '十、サービスの終了',
  'termsOfService.section10.1.title': '10.1 ユーザーによる終了',
  'termsOfService.section10.1.content': 'お客様はいつでも本サービスの使用を停止し、アカウントを削除できます。',
  'termsOfService.section10.2.title': '10.2 プラットフォームによる終了',
  'termsOfService.section10.2.intro': '当社は、以下の状況でお客様のアカウントとサービスを即座に終了または一時停止する権利を有します：',
  'termsOfService.section10.2.item1': 'お客様が本利用規約に違反した場合',
  'termsOfService.section10.2.item2': 'お客様が違法活動を行った場合',
  'termsOfService.section10.2.item3': 'お客様のアカウントが長期間使用されていない場合',
  'termsOfService.section10.2.item4': '法的または規制上の要件',
  'termsOfService.section10.2.note': 'サービス終了後、法律で別段の定めがない限り、お客様はアカウントと生成されたコンテンツにアクセスできなくなります。',
  'termsOfService.section11.title': '十一、紛争解決',
  'termsOfService.section11.1.title': '11.1 協議解決',
  'termsOfService.section11.1.content': '紛争が発生した場合、双方はまず友好的な協議を通じて解決するものとします。',
  'termsOfService.section11.2.title': '11.2 適用法律',
  'termsOfService.section11.2.content': '本利用規約は、中華人民共和国の法律に準拠します。双方が協議を通じて紛争を解決できない場合、当社の所在地を管轄する人民法院に提出するものとします。',
  'termsOfService.section12.title': '十二、その他の条項',
  'termsOfService.section12.1.title': '12.1 条項の変更',
  'termsOfService.section12.1.content': '当社は、いつでも本利用規約を変更する権利を留保します。重要な変更は、発効の少なくとも30日前に通知いたします。サービスの継続使用は、変更された条項に同意したことを意味します。',
  'termsOfService.section12.2.title': '12.2 分離可能性',
  'termsOfService.section12.2.content': '本利用規約のいかなる条項が無効または執行不能と判断された場合でも、他の条項の有効性には影響しません。',
  'termsOfService.section12.3.title': '12.3 完全合意',
  'termsOfService.section12.3.content': '本利用規約は、本サービスの使用に関するお客様と当社の間の完全な合意を構成し、以前のすべての口頭または書面による合意に取って代わります。',
  'termsOfService.section13.title': '十三、お問い合わせ',
  'termsOfService.section13.intro': '本利用規約に関するご質問がございましたら、以下の方法で当社にお問い合わせください：',
  'termsOfService.section13.email': 'メール：{email}',
  'termsOfService.section13.hours': 'カスタマーサポート時間：平日 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'AI生成サービスを提供します。',
  'footer.joinUs': '採用情報',
  'footer.product.title': '製品',
  'footer.product.signup': 'アカウント登録',
  'footer.product.login': 'ログイン',
  'footer.product.workspace': 'ワークスペース',
  'footer.product.works': 'マイ作品',
  'footer.support.title': 'サポート',
  'footer.support.help': 'ヘルプセンター',
  'footer.support.about': '私たちについて',
  'footer.support.feedback': 'フィードバック',
  'footer.support.contact': 'お問い合わせ',
  'footer.legal.title': '法的',
  'footer.legal.privacy': 'プライバシーポリシー',
  'footer.legal.terms': '利用規約',
  'footer.legal.recharge': 'チャージ規約',
  'footer.resources.title': 'リソース',
  'footer.resources.invite': '友達を招待',
  'footer.resources.account': 'アカウント管理',
  'footer.resources.orders': '注文センター',
  'footer.copyright': '© {year} {brand}. 全著作権所有。',
  'footer.description': '本プラットフォームはAI生成サービスを提供しています',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': '仕様比較と業界インサイトを備えたグローバル人型ロボットデータベース',
  'footer.openRobotX.visit': 'Open Robot X を訪問',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': 'AI総合生成プラットフォーム、多様なデジタルコンテンツ制作ツールを提供',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': '個人クラウド音楽：発見、プレイリスト、再生中、クラウド音庫',
  
  // 価格設定ページ
  'pricing.title': 'あなたに合ったプランを選択',
  'pricing.plan.basic.sub': 'ベーシック',
  'pricing.plan.pro.sub': 'プロ',
  'pricing.plan.team.sub': 'チーム',
  'pricing.plan.popular': '人気',
  'pricing.plan.button.select': 'このプランを選択',
  'pricing.plan.button.subscribe': '今すぐ購読',
  'pricing.plan.basic.videoQuota': '5回/月',
  'pricing.plan.basic.videoDuration': '6-10秒',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30回/月',
  'pricing.plan.pro.videoDuration': '10-15秒',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100回/月',
  'pricing.plan.team.videoDuration': '10-15秒',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': '動画生成クォータ',
  'pricing.feature.videoDuration': '動画時間',
  'pricing.feature.videoQuality': '動画品質',
  'pricing.feature.storyboard': 'ストーリーボード機能',
  'pricing.feature.workflow': 'ワークフロー',
  'pricing.feature.priorityQueue': '優先キュー',
  'pricing.feature.exclusiveChannel': '専用チャネル',
  'pricing.feature.highestQuality': '最高品質モード',
  'pricing.feature.sdImage': 'SD画像生成',
  'pricing.feature.unlimited': '無制限',
  'pricing.feature.promptOptimization': 'プロンプト最適化',
  'pricing.feature.imageSize': '画像サイズ',
  'pricing.feature.storage': 'ストレージ容量',
  'pricing.feature.commercialLicense': '商用ライセンス',
  'pricing.feature.apiAccess': 'APIアクセス',
  'pricing.then': 'その後',
  'cta.title': '動画制作を始めましょう',
  'cta.description': '今すぐ登録して、AI技術でクリエイティビティを驚くべき動画作品に変換しましょう',
  'cta.button': '無料で制作を始める',
  'technology.coreArchitecture': 'コアアーキテクチャ',
  'technology.workflowEngine.title': 'ビジュアルワークフローエンジン',
  'technology.workflowEngine.description': 'ビジュアルワークフローサポートが間もなく登場。各ノードは、創造性に対する精密な制御です。',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': 'システムリソースモニター',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': 'ワークフローを実行',
  'technology.button.running': '実行中...',
  'technology.log.systemInitialized': '> システムが初期化されました。',
  'technology.log.waitingForInput': '> ユーザー入力を待機中...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': '究極のパフォーマンスベンチマーク',
  'technology.benchmark.description': 'この0.5秒の改善のために、基盤となる演算子の30%を書き直しました。',
  'technology.benchmark.fps.title': '生成速度 (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'VRAM最適化',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': 'オープンエコロジー',
  'technology.galaxy.title': '無限のモデル宇宙',
  'technology.galaxy.description': 'Civitai直接接続をサポート、数千のモデル、ワンクリックでロード。',
  'technology.galaxy.autoSync': '自動同期',
  
  // フィードバックページ
  'feedback.leftPanel.title.line1': '私たちは',
  'feedback.leftPanel.title.line2': 'あなたの声を聞いています',
  'feedback.leftPanel.description': 'あなたのフィードバックは、私たちの製品改善の原動力です。バグを発見した場合でも、素晴らしい新機能のアイデアがある場合でも、お知らせください。',
  'feedback.contact.helpDoc.title': 'ヘルプドキュメント',
  'feedback.contact.helpDoc.desc': 'よくある質問とユーザーガイドを参照',
  'feedback.contact.email.title': 'メールサポート',
  'feedback.contact.service.title': 'オンラインサポート',
  'feedback.contact.service.hours': '平日 9:00 - 18:00',
  'feedback.type.suggestion.title': '機能提案',
  'feedback.type.suggestion.desc': '新しいアイデアや改善提案があります',
  'feedback.type.bug.title': 'バグレポート',
  'feedback.type.bug.desc': 'エラーや例外が発生しました',
  'feedback.type.question.title': '使用に関する問い合わせ',
  'feedback.type.question.desc': '機能の使い方がわかりません',
  'feedback.type.other.title': 'その他',
  'feedback.type.other.desc': 'その他のフィードバック',
  'feedback.form.type.label': 'フィードバックタイプ',
  'feedback.form.title.label': '簡潔な概要',
  'feedback.form.title.placeholder': '問題や提案を一言で説明してください',
  'feedback.form.title.required': 'タイトルを入力してください',
  'feedback.form.content.label': '詳細な説明',
  'feedback.form.content.placeholder': '背景、再現手順、具体的な提案などを詳しく説明してください...',
  'feedback.form.content.required': '詳細な内容を入力してください',
  'feedback.form.attachment.label': '添付ファイル（オプション）',
  'feedback.upload.dragText': 'クリックまたはファイルをドラッグしてアップロード',
  'feedback.upload.hint': 'JPG、PNG、PDFなどの形式をサポート、単一ファイルサイズは5MB以下',
  'feedback.upload.sizeLimit': 'ファイルサイズは5MBを超えることはできません',
  'feedback.form.priority.label': '優先度',
  'feedback.priority.low.label': '低',
  'feedback.priority.low.desc': '使用に影響なし',
  'feedback.priority.medium.label': '中',
  'feedback.priority.medium.desc': 'ユーザー体験に影響',
  'feedback.priority.high.label': '高',
  'feedback.priority.high.desc': '使用を深刻に妨げる',
  'feedback.form.contact.label': '連絡先（オプション）',
  'feedback.form.contact.placeholder': 'メールまたは電話番号',
  'feedback.form.submit': 'フィードバックを送信',
  'feedback.submit.error': '送信に失敗しました。後でもう一度お試しください',
  'feedback.success.title': 'フィードバックを受信しました！',
  'feedback.success.description': '貴重なフィードバックをありがとうございます。製品チームはすべてのフィードバックを注意深く読みます。バグレポートの場合、提供された連絡先を通じてお問い合わせする場合があります。',
  'feedback.success.back': '戻る',
  'feedback.success.another': 'もう一度送信',
  // 招待ページ
  'invite.partnerProgram': 'パートナープログラム',
  'invite.title.line1': '友達を招待',
  'invite.title.line2': '無限の価値を共創',
  'invite.reward.inviter': '友達を1人招待するごとに、{amount} の現金報酬を獲得できます。',
  'invite.reward.invitee': '友達は登録時に {amount} の新規特典を受け取れます。',
  'invite.step1.title': '1. リンクを共有',
  'invite.step1.desc': 'SNSで専用リンクを共有',
  'invite.step2.title': '2. 友達がアクティブ化',
  'invite.step2.desc': '友達が登録と認証を完了',
  'invite.step3.title': '3. 収益を引き出し',
  'invite.step3.desc': '収益は即時入金、残高に引き出し可能',
  'invite.exclusiveCode': 'YOUR EXCLUSIVE CODE',
  'invite.copyCode': 'コードをコピー',
  'invite.viewQrcode': 'QRコードを表示',
  'invite.stats.totalInvites': '累計招待',
  'invite.stats.availableReward': '引き出し可能額',
  'invite.stats.totalReward': '累計収益',
  'invite.withdrawNow': '今すぐ引き出し',
  'invite.history.title': '招待履歴',
  'invite.filter.all': 'すべて',
  'invite.filter.active': 'アクティブ',
  'invite.filter.pending': '保留中',
  'invite.status.credited': '入金済み',
  'invite.status.pending': '保留中',
  'invite.history.empty': '記録がありません',
  'invite.withdraw.title': '収益の引き出し',
  'invite.withdraw.cancel': 'キャンセル',
  'invite.withdraw.confirm': '引き出しを確認',
  'invite.withdraw.amount': '引き出し金額',
  'invite.withdraw.note': '* 金額は直接アカウント残高に振り込まれます。',
  'invite.withdraw.enterAmount': '引き出し金額を入力してください',
  'invite.withdraw.insufficientBalance': '残高不足',
  'invite.withdraw.success': '¥{amount} を残高に引き出しました',
  'invite.qrcode.title': 'スキャンして参加',
  'invite.copyLink': 'リンクをコピー',
  'invite.copy.success': 'コピーしました',
  // ホームヒーローセクション
  'home.hero.badge': 'AIアシスタント · パートナー · 仲間',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': 'あなたのクラスメート、ソウルメイト、チームメイト',
  'home.hero.description': 'AIMATEXは、あなたのAIアシスタント、学習パートナー、創造的な仲間です。包括的なAIソリューションを提供し、AIを仕事、学習、創造における最良のパートナーにします。教室での学習、創造的なコラボレーション、チーム協力のいずれにおいても、AIMATEXは信頼できるパートナーです。',
  'home.hero.cta.signup': '無料で始める',
  'home.hero.cta.login': 'ログイン',
  'home.hero.cta.workspace': 'ワークスペースへ',
  // ホーム製品セクション
  'home.products.title': '私たちの製品',
  'home.products.subtitle': 'AIMATEXの革新的なAI製品を探索し、各製品は異なるシナリオでの最良のパートナーです',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'AI画像から動画への作成パートナー、静的な画像を動的な動画に変換し、あなたの創造性を生き生きとさせます',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'AI駆動の3Dオブジェクト生成・変換プラットフォーム、あなたの3D作成パートナー',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': 'グローバルな人型ロボット企業、パラメータ比較、業界インサイトを探索、あなたのロボット研究パートナー',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': '自律エージェントプラットフォーム — OpenForgeX でインテリジェントエージェントを構築・デプロイ',
  'home.products.openclaw4j.cta': 'エージェントを試す',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': '個人向けクラウド音楽スペース。楽曲発見、プレイリスト共有、再生中、クラウド音庫をひとつに',
  'home.products.aimatexMusic.cta': '音楽へ',
  'home.music.eyebrow': 'AIMATEX スイート',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': '個人向けクラウド音楽スペース。発見、収集、共有再生をひとつに。',
  'home.music.feature.discover.title': '発見',
  'home.music.feature.discover.desc': '楽曲を検索してクラウド音庫へ取り込み。',
  'home.music.feature.playlist.title': 'プレイリスト',
  'home.music.feature.playlist.desc': '共同プレイリストを作成・共有。',
  'home.music.feature.nowPlaying.title': '再生中',
  'home.music.feature.nowPlaying.desc': '同期再生、お気に入り、再生履歴。',
  'home.music.feature.cloud.title': 'クラウド音庫',
  'home.music.feature.cloud.desc': '高音質オーディオを安全に保存。',
  'home.music.cta': 'AIMATEX-MUSIC を開く',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': '詳細を見る',
  // ホーム機能セクション
  'home.features.title': 'オールインワン創作ワークショップ。',
  'home.features.subtitle': '動画生成だけでなく、創造性を全方位的に支援します。',
  'home.features.aiPrompt.title': 'プロンプトが書けない？AIが書きます',
  'home.features.aiPrompt.description': '全くアイデアがない？ワンクリックでAIが書きます。数語入力するだけで、AIが自動的に映画レベルの説明に磨き上げ、10秒で出力。スタイルを変えたい？もう一度クリックすれば、サイバーパンク/油絵/アニメに即変換。',
  'home.features.demo.userInput': '猫',
  'home.features.demo.aiResult': '優雅なペルシャ猫、柔らかくふわふわした白い長毛、琥珀色の大きな瞳、日差しの差し込む窓辺に座っている。背景は淡い青空と揺れる白いカーテン。4K高画質、映画のような照明、被写界深度、プロの写真撮影。',
  'home.features.demo.buttonText': 'AI生成',
  'home.features.demo.buttonLoading': '生成中',
  'home.features.demo.thinkingText': 'AI創作中✨',
  'home.features.quality.title': '映画品質',
  'home.features.quality.description': 'ネイティブで4K解像度出力をサポート、すべてのフレームが繊細です。',
  'home.features.imageToVideo.title': '画像から動画',
  'home.features.imageToVideo.description': '静止画像をアップロードすると、AIがシーンの光と物理関係を理解し、自動的に後続の動きを生成し、写真を生き生きとさせます。',
  'home.features.multimodal.title': 'マルチモーダルエコシステム',
  'home.features.multimodal.description': 'Stable Diffusionのテキストから画像だけでなく、Midjourneyのスタイル転送とElevenLabsのオーディオ合成も統合。1つのワークフローですべての創作を完了。',
  
  // ホームコミュニティセクション
  'home.community.title': 'AIクリエイティブコミュニティを探索',
  'home.community.subtitle': '数百万のクリエイターに参加し、AIの傑作を共有し、インスピレーションとフィードバックを得る',
  'home.community.hot': '人気',
  'home.community.explore': 'コミュニティを探索',
  'home.community.stats.works': '作品',
  'home.community.stats.creators': 'クリエイター',
  'home.community.stats.views': '閲覧',
  'home.community.image.title': 'AI画像コミュニティ',
  'home.community.image.description': 'フォトリアリスティックからアーティスティック、イラストから写真まで、AIが生成した素晴らしい画像を発見して共有',
  'home.community.video.title': 'AIビデオコミュニティ',
  'home.community.video.description': 'AIが生成した素晴らしいビデオを探索し、クリエイティブなテクニックを学び、世界中のビデオクリエイターと交流',
  'home.community.music.title': 'AI音楽コミュニティ',
  'home.community.music.description': 'AIが作曲した美しいメロディーを聴き、音楽作品を共有し、同じ志を持つ音楽愛好家を見つける',
  'home.community.3d.title': 'AI 3Dモデルコミュニティ',
  'home.community.3d.description': '建築からキャラクター、ゲームから産業デザインまで、AIが生成した3Dモデルの世界を探索',
  'home.community.voice.title': 'AI音声コミュニティ',
  'home.community.voice.description': 'リアルなAI音声合成、吹き替え、オーディオブック、ボイスクローニングを体験し、創作に命を吹き込む',
  'home.community.text.title': 'AIテキストコミュニティ',
  'home.community.text.description': 'AIが作成した優れたテキスト、小説、詩、脚本、コピーライティングを共有し、文学的な創造性を刺激',
  
  // 請求ページ
  'billing.page.title': '財務センター',
  'billing.page.description': '資金の出入りと請求明細を管理',
  'billing.button.refresh': '更新',
  'billing.button.recharge': 'チャージ',
  'billing.button.reset': 'リセット',
  'billing.button.apply': 'フィルタを適用',
  
  // 残高カード
  'billing.balance.cny': 'CNY残高',
  'billing.balance.usdt': 'USDT残高',
  'billing.balance.usd': 'USD残高',
  'billing.balance.token': 'トークン残高',
  'billing.balance.frozen': '凍結',
  
  // 取引タイプ
  'billing.type.frozen': '資金凍結',
  'billing.type.aiModelFee': 'モデル呼び出し',
  'billing.type.recharge': 'チャージ',
  'billing.type.refund': '返金',
  'billing.type.reward': '報酬',
  'billing.type.all': 'すべてのタイプ',
  
  // 通貨
  'billing.coin.all': 'すべての通貨',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  
  // テーブル
  'billing.table.type': 'タイプ',
  'billing.table.coinType': '通貨',
  'billing.table.time': '時間',
  'billing.table.amount': '金額',
  'billing.table.remark': '備考',
  'billing.table.balance': '残高',
  'billing.table.empty': '請求書なし',
  
  // フィルタ
  'billing.filter.title': 'フィルタ条件',
  'billing.filter.button': 'フィルタと日付',
  'billing.filter.changeType': '変更タイプ',
  'billing.filter.coinType': '通貨タイプ',
  'billing.filter.remark': '備考検索',
  'billing.filter.remarkPlaceholder': '備考キーワードを入力',
  'billing.filter.remarkSearch': '備考検索',
  'billing.filter.dateQuick': 'クイック日付',
  'billing.filter.dateCustom': 'カスタム日付',
  'billing.filter.dateTo': 'から',
  'billing.filter.days7': '過去7日間',
  'billing.filter.days30': '過去30日間',
  'billing.filter.days90': '過去3ヶ月',
  
  // プレースホルダー
  'billing.placeholder.changeType': '変更タイプ',
  'billing.placeholder.coinType': '通貨',
  'billing.placeholder.remark': '備考検索',
  
  // メッセージ
  'billing.message.fetchBalanceError': '残高の取得に失敗しました',
  'billing.message.fetchRecordsError': '請求記録の取得に失敗しました',
  'billing.message.tryAgain': '請求記録の取得に失敗しました。後でもう一度お試しください',
  
  // チャージページ
  'recharge.page.title': 'アカウントチャージ',
  'recharge.page.backLink': '財務センターに戻る',
  'recharge.balance.title': 'アカウント残高',
  'recharge.balance.refresh': '更新',
  
  // チャージセクション
  'recharge.section.coinType': 'チャージ通貨',
  'recharge.section.paymentMethod': '支払い方法',
  'recharge.section.amount': 'チャージ金額',
  
  // 注文詳細
  'recharge.order.title': '注文詳細',
  'recharge.order.type': 'チャージタイプ',
  'recharge.order.typeValue': 'アカウント残高チャージ',
  'recharge.order.account': 'チャージアカウント',
  'recharge.order.accountLoading': '読み込み中...',
  'recharge.order.paymentMethod': '支払い方法',
  'recharge.order.paymentMethodPlease': '選択してください',
  'recharge.order.total': '支払い総額',
  
  // ボタン
  'recharge.button.pay': '今すぐ支払う',
  'recharge.button.customize': 'カスタム金額',
  
  // プレースホルダー
  'recharge.placeholder.customAmount': 'カスタム金額を入力',
  
  // セキュリティ
  'recharge.security.ssl': 'SSL暗号化通信、資金の安全を保護',
  'recharge.security.agreement': '支払いをクリックすると同意したことになります',
  'recharge.security.agreementLink': 'チャージサービス契約',
  
  // 空状態
  'recharge.empty.noCurrency': 'サポートされている通貨はありません',
  'recharge.empty.noPaymentMethod': '{currency} 通貨の支払い方法はサポートされていません',
  'recharge.empty.pleaseSelectCurrency': '先にチャージ通貨を選択してください',
  'recharge.empty.pleaseSelectPayment': '先に支払い方法を選択してください',
  'recharge.empty.noProducts': '利用可能な製品はありません',
  'recharge.empty.noPresets': '{currency} 通貨のプリセット金額はサポートされていません',
  
  // メッセージ
  'recharge.message.invalidAmount': '有効な金額を入力してください',
  'recharge.message.selectPaymentMethod': '支払い方法を選択してください',
  'recharge.message.selectAmount': 'チャージ金額を選択してください',
  'recharge.message.fetchBalanceError': '残高の取得に失敗しました。後でもう一度お試しください',
  'recharge.message.fetchUserInfoError': 'ユーザー情報の取得に失敗しました',
  'recharge.message.fetchCurrenciesError': '通貨リストの取得に失敗しました。後でもう一度お試しください',
  'recharge.message.fetchPaymentMethodsError': '支払い方法の取得に失敗しました。後でもう一度お試しください',
  'recharge.message.fetchCreemProductsError': 'Creem製品リストの取得に失敗しました。後でもう一度お試しください',
  'recharge.message.fetchCreemProductsWarning': 'Creem製品リストの取得に失敗しました',
  'recharge.message.orderCreated': '注文が正常に作成されました',
  'recharge.message.orderCreateFailed': 'チャージ注文の作成に失敗しました',
  'recharge.message.paymentProcessing': '支払いページを開いています。支払いを完了してください...',
  'recharge.message.popupBlocked': '支払いウィンドウを開けません。ブラウザのポップアップ設定を確認してください',
  'recharge.message.paymentUrlError': '支払いリンクの取得に失敗しました',
  'recharge.message.checkoutSessionError': '支払いセッションの作成に失敗しました',
  'recharge.message.paymentError': '支払い処理に失敗しました。後でもう一度お試しください',
  'recharge.message.redirecting': '支払いページにリダイレクトしています。支払いを完了してください...',
  'recharge.message.paymentUrlFailed': '支払いリンクが利用できません',
  'recharge.message.paymentSuccess': '支払いが成功しました！残高が更新されました',
  'recharge.message.orderCancelled': '注文がキャンセルされました',
  'recharge.message.paymentFailed': '支払いに失敗しました',
  'recharge.message.orderExpired': '期限切れ',
  'recharge.message.queryOrderError': '注文ステータスの照会に失敗しました',
  'recharge.message.rechargeError': 'チャージリクエストに失敗しました。後でもう一度お試しください',

  // 注文ページ
  'orders.title': '注文履歴',
  'orders.subtitle': 'すべてのチャージ注文記録とステータスを表示',
  'orders.refresh': '更新',
  'orders.goToRecharge': 'チャージ',

  // 統計カード
  'orders.stats.totalOrders': '総注文数',
  'orders.stats.pending': '支払待ち',
  'orders.stats.paid': '支払済み',
  'orders.stats.totalAmount': '総チャージ金額',

  // テーブル列
  'orders.table.orderNo': '注文番号',
  'orders.table.createTime': '作成日時',
  'orders.table.amount': '金額',
  'orders.table.paymentMethod': '支払方法',
  'orders.table.status': 'ステータス',
  'orders.table.action': '操作',
  'orders.table.view': '表示',
  'orders.table.cancel': 'キャンセル',
  'orders.table.empty': '注文記録がありません',

  // 注文ステータス
  'orders.status.pending': '支払待ち',
  'orders.status.paid': '支払済み',
  'orders.status.success': '完了',
  'orders.status.cancelled': 'キャンセル済み',
  'orders.status.failed': '失敗',
  'orders.status.expired': '期限切れ',
  'orders.status.all': 'すべてのステータス',

  // 支払方法
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': '銀行カード',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': 'すべての方法',

  // 通貨
  'orders.coin.all': 'すべての通貨',

  // フィルター
  'orders.filter.title': 'フィルターオプション',
  'orders.filter.button': '注文をフィルター',
  'orders.filter.reset': 'リセット',
  'orders.filter.apply': '適用',
  'orders.filter.orderStatus': '注文ステータス',
  'orders.filter.paymentMethod': '支払方法',
  'orders.filter.coinType': '通貨タイプ',
  'orders.filter.orderNoSearch': '注文番号を検索',
  'orders.filter.quickDate': 'クイック日付',
  'orders.filter.customDate': 'カスタム日付',
  'orders.filter.dateTo': 'から',
  'orders.filter.last7Days': '過去7日間',
  'orders.filter.last30Days': '過去30日間',
  'orders.filter.last3Months': '過去3ヶ月',

  // 検索と入力
  'orders.search.placeholder': '注文番号を検索',
  'orders.input.orderNo': '注文番号を入力',
  'orders.select.orderStatus': '注文ステータス',
  'orders.select.paymentMethod': '支払方法',
  'orders.select.coinType': '通貨',

  // メッセージ
  'orders.message.fetchError': '注文の取得に失敗しました',
  'orders.message.fetchErrorRetry': '注文の取得に失敗しました。後でもう一度お試しください',
  'orders.message.statsError': '統計の取得に失敗しました',
  'orders.message.cancelSuccess': '注文をキャンセルしました',
  'orders.message.cancelError': '注文のキャンセルに失敗しました',
  'orders.message.cancelErrorRetry': '注文のキャンセルに失敗しました。後でもう一度お試しください',
  'orders.message.viewOrder': '注文番号: {orderNo}',

  // 確認ダイアログ
  'orders.confirm.cancel': 'この注文をキャンセルしてもよろしいですか？',
  'orders.confirm.ok': 'OK',
  'orders.confirm.cancelButton': 'キャンセル',

  // 採用ページ
  'joinUs.seo.title': 'PROTX に参加 - 極致を追求',
  'joinUs.seo.description': 'PROTX チームに参加し、究極のユーザー体験とプロダクトデザインを一緒に追求しましょう',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': '極致を追求',
  'joinUs.hero.title2': 'デザインで未来を定義する',
  'joinUs.hero.subtitle': 'PROTX は究極のユーザー体験とプロダクトデザインを追求するチームです。すべてのピクセルには意味があり、すべてのインタラクションは丁寧に磨き上げる価値があると信じています。卓越性への執着を共有するあなたを待っています。',
  'joinUs.hero.cta': '募集職種を見る',
  'joinUs.hero.video': 'チームストーリーを見る',
  
  'joinUs.values.eyebrow': '私たちの理念',
  'joinUs.values.title': 'コアバリュー',
  'joinUs.values.subtitle': 'これらのコアバリューが、私たちが誰であり、どのように協力するかを定義します',
  'joinUs.values.innovation.title': 'イノベーション主導',
  'joinUs.values.innovation.desc': 'イノベーションこそが世界を変える力であると信じ、あらゆる画期的なアイデアを奨励します。',
  'joinUs.values.collaboration.title': 'コラボレーション',
  'joinUs.values.collaboration.desc': 'チームの垣根を越えた協力で、非凡な成果を創出。',
  'joinUs.values.excellence.title': '卓越性の追求',
  'joinUs.values.excellence.desc': '常に限界を突破し、究極の体験を追求。',
  'joinUs.values.passion.title': '情熱と専念',
  'joinUs.values.passion.desc': 'テクノロジーへの情熱、製品への専念。',
  'joinUs.values.impact.title': 'インパクト',
  'joinUs.values.impact.desc': 'AI技術であらゆる人の創造的表現を支援。',
  
  'joinUs.positions.eyebrow': '募集職種',
  'joinUs.positions.title': '募集職種',
  'joinUs.positions.subtitle': '自分に合った役割を見つけて、新しいキャリアの旅を始めましょう',
  'joinUs.category.engineering': 'エンジニアリング',
  'joinUs.category.product': 'プロダクト＆デザイン',
  'joinUs.category.operations': '運営＆マーケティング',
  'joinUs.position.seniorFrontend': 'シニアフロントエンドエンジニア',
  'joinUs.position.backendEngineer': 'バックエンドエンジニア',
  'joinUs.position.mlEngineer': 'AI/MLエンジニア',
  'joinUs.position.productManager': 'プロダクトマネージャー',
  'joinUs.position.uxDesigner': 'UXデザイナー',
  'joinUs.position.communityManager': 'コミュニティマネージャー',
  'joinUs.position.contentCreator': 'コンテンツクリエイター',
  'joinUs.location.remote': 'リモート',
  'joinUs.location.beijing': '北京',
  'joinUs.location.shanghai': '上海',
  'joinUs.location.shenzhen': '深セン',
  'joinUs.type.fulltime': '正社員',
  'joinUs.type.parttime': 'パートタイム',
  
  'joinUs.benefits.eyebrow': '福利厚生',
  'joinUs.benefits.title': '私たちが提供するもの',
  'joinUs.benefits.subtitle': '私たちに参加して、充実した福利厚生とサポートを享受しましょう',
  'joinUs.benefit.flexible.title': 'フレキシブルワーク',
  'joinUs.benefit.flexible.desc': '柔軟な勤務時間とリモートワークオプション',
  'joinUs.benefit.equity.title': 'ストックオプション',
  'joinUs.benefit.equity.desc': '会社と共に成長し、成功を分かち合う',
  'joinUs.benefit.health.title': '健康保険',
  'joinUs.benefit.health.desc': '充実した医療保険と健康サポート',
  'joinUs.benefit.growth.title': 'キャリア成長',
  'joinUs.benefit.growth.desc': '継続的な学習と成長の機会',
  
  'joinUs.cta.title': '始める準備はできましたか？',
  'joinUs.cta.subtitle': '私たちのミッションに情熱を持っているなら、ぜひご応募ください',
  'joinUs.cta.button': '今すぐ応募',
  
  'joinUs.modal.title': '職種応募',
  'joinUs.apply.success': '応募が送信されました。まもなくご連絡いたします！',
  'joinUs.form.name': '氏名',
  'joinUs.form.name.required': '氏名を入力してください',
  'joinUs.form.name.placeholder': '氏名を入力',
  'joinUs.form.email': 'メールアドレス',
  'joinUs.form.email.required': 'メールアドレスを入力してください',
  'joinUs.form.email.invalid': '有効なメールアドレスを入力してください',
  'joinUs.form.email.placeholder': 'メールアドレスを入力',
  'joinUs.form.phone': '電話番号',
  'joinUs.form.phone.placeholder': '電話番号を入力',
  'joinUs.form.experience': '職務経験',
  'joinUs.form.experience.placeholder': '経験年数を選択',
  'joinUs.form.experience.0-2': '0-2年',
  'joinUs.form.experience.3-5': '3-5年',
  'joinUs.form.experience.5-10': '5-10年',
  'joinUs.form.experience.10+': '10年以上',
  'joinUs.form.resume': '履歴書',
  'joinUs.form.resume.hint': 'クリックまたはドラッグしてアップロード',
  'joinUs.form.resume.format': 'PDF、DOC、DOCX形式に対応',
  'joinUs.form.message': '自己紹介',
  'joinUs.form.message.placeholder': '自己紹介と志望動機を教えてください',
  'joinUs.form.submit': '応募する',
  'joinUs.form.loginTip': 'ログイン後に応募すると、応募履歴を確認できます',
  'joinUs.form.goLogin': 'ログイン',
  'joinUs.form.resume.sizeLimit': 'ファイルサイズは10MB以下にしてください',
  
  // 応募履歴
  'joinUs.myApplications.eyebrow': '応募履歴',
  'joinUs.myApplications.title': '応募記録',
  'joinUs.myApplications.empty': 'まだ応募がありません。履歴書を提出しましょう！',
  'joinUs.myApplications.viewDetail': '詳細を見る',
  'joinUs.myApplications.detailTitle': '応募詳細',
  'joinUs.status.pending': '審査待ち',
  'joinUs.status.reviewing': '審査中',
  'joinUs.status.interview': '面接中',
  'joinUs.status.accepted': '採用',
  'joinUs.status.rejected': '不採用',
  'joinUs.detail.basicInfo': '基本情報',
  'joinUs.detail.positionInfo': '職種情報',
  'joinUs.detail.position': '応募職種',
  'joinUs.detail.category': 'カテゴリ',
  'joinUs.detail.location': '勤務地',
  'joinUs.detail.applyTime': '応募日時',
  'joinUs.detail.downloadResume': '履歴書をダウンロード',
  'joinUs.detail.status': '応募状態',

  // About ページ
  'about.hero.title1': 'オープンソースコア。',
  'about.hero.title2': '無限の可能性。',
  'about.hero.subtitle1': '',
  'about.hero.subtitle2': 'と',
  'about.hero.subtitle3': 'エコシステムをベースに。',
  'about.hero.description': '最先端の2025年生成AI技術スタックを、究極のインタラクティブ体験にパッケージ化しています。',
  'about.tech.poweredBy': 'Powered by',
  'about.philosophy.title1': '生成だけではない。',
  'about.philosophy.title2': 'これはフルプロセスの',
  'about.philosophy.title3': 'クリエイティビティエンジン。',
  'about.philosophy.description': 'テキスト生成画像の精密制御から、動画生成の物理シミュレーションまで、技術の限界を追求します。',
  'about.bento.comfy.title': 'ノードレベルの精密制御。',
  'about.bento.comfy.description': 'ComfyUIノードベースアーキテクチャを採用し、ControlNetポーズ制御とIP-Adapterスタイル転送をサポート。複雑なノードロジックを直感的なスライダーにカプセル化し、すべての生成を思い通りに。',
  'about.bento.opensource.title': 'オープンソースを採用。',
  'about.bento.opensource.description': 'Stable Diffusion 3.5 & XL Turboをベースに。高速生成だけでなく、コミュニティの膨大なLoRAモデルサポートも。',
  'about.bento.video.title': 'DiT動画アーキテクチャ。',
  'about.bento.video.description': 'Diffusion Transformer (DiT)と時空間アテンションメカニズムを導入し、SORAレベルの物理世界シミュレーションを実現。',
  'about.bento.audio.title': '音と映像の同期、感覚の覚醒。',
  'about.bento.audio.description': '視覚だけではない。最新のオーディオ生成モデルを統合し、Text-to-Audioと動画の自動アライメントをサポート。視覚から聴覚まで、完全な没入体験を構築。',
  'about.techSection.title': '技術アーキテクチャ解析。',
  'about.techSection.description': 'ProductXを動かすコアエンジンを深く理解する。',
  'about.techCard.sd.title': '生成アートの基盤。',
  'about.techCard.sd.description': '最新のStable Diffusion生成モデルを深く統合。カスタムVAEと最適化されたサンプラーにより、繊細な画質を維持しながら生成速度を300%向上。',
  'about.techCard.spec.baseModel': 'ベースモデル',
  'about.techCard.spec.resolution': '解像度',
  'about.techCard.spec.resolution.value': '最大4Kアップスケーリング',
  'about.techCard.spec.control': '制御',
  'about.techCard.spec.speed': '速度',
  'about.techCard.spec.speed.value': '< 1秒（ターボモード）',
  'about.techCard.video.title': '次世代動画物理エンジン。',
  'about.techCard.video.description': '従来の2Dアニメーションロジックを捨て、2025年最新のDiT（Diffusion Transformer）アーキテクチャを採用。モデルは光と影、重力、物体の動きの法則を理解し、単なる動画ではなく、物理的に正確な動的世界を生成。',
  'about.techCard.spec.architecture': 'アーキテクチャ',
  'about.techCard.spec.frameRate': 'フレームレート',
  'about.techCard.spec.frameRate.value': '24 / 60 FPS補間',
  'about.techCard.spec.consistency': '一貫性',
  'about.techCard.spec.consistency.value': '高い時間的安定性',
  'about.techCard.spec.length': '長さ',
  'about.techCard.spec.length.value': '無限ループ拡張',
  'about.techCard.img2img.title': '画像から画像&スタイル転送。',
  'about.techCard.img2img.description': 'IP-AdapterとT2I-Adapter技術を使用し、ゼロショットスタイル転送を実現。参照画像をアップロードするだけで、その構図、照明、アートスタイルを即座に再現し、無限のクリエイティブ可能性を解放。',
  'about.techCard.spec.technology': '技術',
  'about.techCard.spec.precision': '精度',
  'about.techCard.spec.precision.value': 'ピクセルパーフェクトインペインティング',
  'about.cta.title': '未来を体験する準備はできましたか？',
  'about.cta.description': 'プロのクリエイターに加わり、AIの究極の可能性を解放しましょう。',
  'about.cta.button.start': '今すぐ始める',
  'about.cta.button.docs': 'ドキュメントを読む',
  
  // Community コミュニティ
  'community.explore.title': 'コミュニティを探索',
  'community.explore.subtitle': 'インスピレーションを発見し、ワークフローをリミックスし、数千人のAIクリエイターとつながりましょう。',
  'community.posts': '{count} 投稿',
  'community.empty': 'コミュニティチャンネルがありません',
  'community.loadFailed': '読み込みに失敗しました',
  'community.noPosts': 'まだ投稿がありません',
  'community.challenge.loadFailed': 'チャレンジデータの読み込みに失敗しました',
  
  'common.loadFailed': '読み込みに失敗しました',
  'common.operationFailed': '操作に失敗しました',
  'common.error': '操作に失敗しました',
  'common.publish': '公開',
  'common.back': '戻る',
  'common.backToCommunity': 'コミュニティに戻る',
  'common.copy': 'コピー',
  'common.copied': 'コピーしました',
  'common.follow': 'フォロー',
  'common.processing': '処理中...',
  'common.viewCount': '{count} 回閲覧',
  'common.loadMore': 'もっと見る',
  'common.search': '検索...',
  'common.notFound': '見つかりません',
  'common.description': '説明',
  
  'user.followSuccess': 'フォローしました',
  'user.unfollowSuccess': 'フォローを解除しました',
  'user.following': 'フォロー中',
  'user.mutual_follow': '相互フォロー',
  
  'post.untitled': '無題の作品',
  'post.prompt': 'プロンプト',
  'post.negativePrompt': 'ネガティブプロンプト',
  'post.details': '詳細',
  'post.model': 'モデル',
  'post.resolution': '解像度',
  'post.steps': 'ステップ数',
  'post.cfgScale': 'ガイダンススケール',
  'post.remix': 'リミックス / これを試す',
  
  'challenge.status.upcoming': '開催予定',
  'challenge.status.live': '開催中',
  'challenge.status.voting': '投票中',
  'challenge.status.ended': '終了',
  'challenge.status.unknown': '不明',
  'challenge.allChallenges': 'すべてのチャレンジ',
  'challenge.entriesCount': '{count} 作品',
  'challenge.tab.submissions': '作品',
  'challenge.tab.rules': 'ルールと情報',
  'challenge.requirements': '要件',
  'challenge.req.original': 'オリジナル作品のみ。',
  'challenge.req.model': 'モデルを使用する必要があります：{model}',
  'challenge.req.tags': 'タグを含める必要があります：',
  'challenge.req.resolution': '解像度は少なくとも1024x1024である必要があります。',
  'challenge.req.nsfw': 'NSFWコンテンツは禁止されています。',
  'challenge.timeRemaining': '残り時間',
  'challenge.startsIn': '開始まで',
  'challenge.notStarted': 'チャレンジはまだ開始されていません',
  'challenge.closed': 'チャレンジ終了',
  'challenge.submitEntry': '作品を提出',
  'challenge.viewWinners': '受賞者を見る',
  'challenge.readRulesTip': '提出前にルールを読んでください',
  'challenge.prizePool': '賞金プール',
  'challenge.totalValue': '総額',
  'challenge.rank.1st': '1位',
  'challenge.rank.2nd': '2位',
  'challenge.rank.3rd': '3位',
  'challenge.share': 'チャレンジを共有',
  'challenge.noEntries': 'まだ作品がありません。最初の提出者になりましょう！',
  'challenge.noChallenges': 'チャレンジが見つかりません',
  // MediaTools
  'mediaTools.tab.imageCompress': '画像圧縮',
  'mediaTools.tab.videoCompress': '動画圧縮',
  'mediaTools.tab.audioCompress': '音声圧縮',
  'mediaTools.tab.formatConvert': '形式変換',
  // ImageCompress
  'imageCompress.title': 'プロフェッショナル画像圧縮ツール',
  'imageCompress.subtitle': 'インテリジェント圧縮、プロフェッショナル品質',
  'imageCompress.upload': '画像をアップロード',
  'imageCompress.addImages': '画像を追加',
  'imageCompress.uploadToStart': '画像をアップロードして圧縮を開始',
  'imageCompress.settings': '設定',
  'imageCompress.clearAll': 'すべてクリア',
  'imageCompress.totalSavings': '節約スペース',
  'imageCompress.totalSize': '合計サイズ',
  'imageCompress.quality': '品質',
  'imageCompress.resize': 'サイズ調整',
  'imageCompress.scalePercent': 'スケール %',
  'imageCompress.customPx': 'カスタム px',
  'imageCompress.presetSize': 'プリセットサイズ',
  'imageCompress.width': '幅',
  'imageCompress.height': '高さ',
  'imageCompress.format': '形式',
  'imageCompress.format.auto': '自動（オリジナルを保持）',
  'imageCompress.format.jpeg': 'JPEG（写真）',
  'imageCompress.format.png': 'PNG（可逆圧縮）',
  'imageCompress.format.webp': 'WebP（最適）',
  'imageCompress.pngLossless': 'PNGは可逆圧縮形式です。品質スライダーは非表示です。',
  'imageCompress.cacheSettings': 'キャッシュ設定',
  'imageCompress.cacheTooltip': '有効にすると、アップロードした画像がブラウザキャッシュに保存され、ページをリロード後に復元されます。',
  'imageCompress.saveToCache': '画像をブラウザキャッシュに保存',
  'imageCompress.batchProcessing': '一括処理',
  'imageCompress.batchTooltip': '有効にすると、現在の設定ですべての {count} 枚の画像に圧縮が適用されます。',
  'imageCompress.applyToAll': 'すべての画像に設定を適用（{count}）',
  'imageCompress.compress': '適用して圧縮',
  'imageCompress.compressAll': 'すべてを適用して圧縮（{count}）',
  'imageCompress.compressing': '圧縮中...',
  'imageCompress.compressAllProgress': '{count} 枚の画像を圧縮中...',
  'imageCompress.download': '画像をダウンロード',
  'imageCompress.downloadAll': 'すべてダウンロード（{count}）',
  'imageCompress.downloadAllCheckbox': 'すべての {count} 枚の画像をダウンロード',
  'imageCompress.original': 'オリジナル',
  'imageCompress.compressed': '圧縮後',
  // Messages
  'imageCompress.message.compressed': '圧縮成功！',
  'imageCompress.message.larger': '出力ファイルが大きくなりました。品質を下げてみてください。',
  'imageCompress.message.failed': '圧縮に失敗しました',
  'imageCompress.message.batchSuccess': '{success} 枚の画像の圧縮に成功しました{failed}',
  'imageCompress.message.batchFailed': 'すべての圧縮が失敗しました',
  'imageCompress.message.noImagesToDownload': 'ダウンロードできる圧縮画像がありません',
  'imageCompress.message.downloading': '{count} 枚の画像をダウンロード中...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Instagram投稿 (1:1)',
  'imageCompress.preset.square': '正方形 (1:1)',
  'imageCompress.preset.facebookCover': 'Facebookカバー (16:9)',
  'imageCompress.preset.twitterHeader': 'Twitterヘッダー (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'YouTubeサムネイル (16:9)',
  'imageCompress.preset.facebookPost': 'Facebook投稿 (1.91:1)',
  'imageCompress.preset.instagramStory': 'Instagramストーリー (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'フルHD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': '16:9 横向き',
  'imageCompress.preset.classic4:3': '4:3 クラシック',
  'imageCompress.preset.photo3:2': '3:2 写真',
  'imageCompress.preset.ultrawide21:9': '21:9 ウルトラワイド',
  'imageCompress.preset.a4Portrait': 'A4縦向き (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4横向き (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter縦向き (8.5×11")',
  // AudioCompress
  'audioCompress.title': 'プロフェッショナル音声圧縮ツール',
  'audioCompress.subtitle': 'ブラウザベースの圧縮、プライバシー保護',
  'audioCompress.upload': '音声をアップロード',
  'audioCompress.uploadNew': '新しい音声をアップロード',
  'audioCompress.uploadToStart': '音声をアップロードして圧縮を開始',
  'audioCompress.settings': '設定',
  'audioCompress.clearAll': 'すべてクリア',
  'audioCompress.totalSavings': '節約容量',
  'audioCompress.totalSize': '合計サイズ',
  'audioCompress.audioInfo': '音声情報',
  'audioCompress.quality': '品質',
  'audioCompress.bitrate': 'ビットレート',
  'audioCompress.bitrate.320': '320 kbps (最高品質)',
  'audioCompress.bitrate.256': '256 kbps (高品質)',
  'audioCompress.bitrate.192': '192 kbps (標準品質)',
  'audioCompress.bitrate.128': '128 kbps (中品質)',
  'audioCompress.bitrate.96': '96 kbps (低品質)',
  'audioCompress.bitrate.64': '64 kbps (最低品質)',
  'audioCompress.format': '形式',
  'audioCompress.format.mp3': 'MP3 (推奨)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': 'サンプリングレート',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (CD品質)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': '圧縮開始',
  'audioCompress.compressing': '圧縮中...',
  'audioCompress.download': '音声をダウンロード',
  // AudioCompress Messages
  'audioCompress.message.compressed': '圧縮成功！',
  'audioCompress.message.failed': '圧縮に失敗しました。もう一度お試しください',
  'audioCompress.message.invalidFile': '音声ファイルを選択してください！',
  'audioCompress.message.loadError': '音声ファイルの読み込みに失敗しました',
  
  // Settings
  'settings.title': 'システム設定',
  'settings.description': 'AI生成プラットフォームの体験をカスタマイズ',
  'settings.notifications.title': '通知設定',
  'settings.notifications.description': '通知の受信方法を管理',
  'settings.notifications.email': 'メール通知',
  'settings.notifications.emailDesc': '重要な更新とタスク完了のメールを受信',
  'settings.notifications.push': 'プッシュ通知',
  'settings.notifications.pushDesc': 'リアルタイムのプッシュメッセージを受信',
  'settings.notifications.sound': 'サウンド通知',
  'settings.notifications.soundDesc': '通知到着時にサウンドを再生',
  'settings.notifications.volume': '通知音量',
  'settings.notifications.volumeDesc': '通知音の音量を調整',
  'settings.notifications.marketing': 'マーケティング',
  'settings.notifications.marketingDesc': 'プラットフォームのイベントとプロモーション情報を受信',
  'settings.interface.title': 'インターフェース外観',
  'settings.interface.description': 'インターフェースの表示をカスタマイズ',
  'settings.interface.theme': 'テーマモード',
  'settings.interface.themeDesc': 'お好みのインターフェーステーマを選択',
  'settings.interface.language': '言語',
  'settings.interface.languageDesc': 'インターフェースの表示言語を選択',
  'settings.interface.animation': 'アニメーション効果',
  'settings.interface.animationDesc': 'インターフェース遷移アニメーションを有効化',
  'settings.interface.tips': '初心者向けヒント',
  'settings.interface.tipsDesc': '機能ガイドとヒントを表示',
  'settings.theme.light': 'ライト',
  'settings.theme.dark': 'ダーク',
  'settings.theme.auto': '自動',
  'settings.ai.title': 'AI生成設定',
  'settings.ai.description': 'AI生成効果とパフォーマンスを最適化',
  'settings.ai.autoOptimize': 'スマート最適化',
  'settings.ai.autoOptimizeDesc': 'AIが自動的に生成パラメータを最適化',
  'settings.ai.quality': '生成品質',
  'settings.ai.qualityDesc': '速度と品質のバランス',
  'settings.ai.cloudSync': 'クラウド同期',
  'settings.ai.cloudSyncDesc': '作品を自動的にクラウドに同期',
  'settings.ai.autoSave': '自動保存',
  'settings.ai.autoSaveDesc': '生成完了後に結果を自動保存',
  'settings.ai.safetyFilter': 'コンテンツ安全フィルター',
  'settings.ai.safetyFilterDesc': '不適切なコンテンツを自動フィルタリング',
  'settings.ai.watermark': '透かしを追加',
  'settings.ai.watermarkDesc': '生成作品に自動的に透かしを追加',
  'settings.ai.promptSuggestions': 'プロンプト提案',
  'settings.ai.promptSuggestionsDesc': 'プロンプト最適化のスマート推奨',
  'settings.quality.fast': '高速',
  'settings.quality.balanced': 'バランス',
  'settings.quality.high': '高品質',
  'settings.privacy.title': 'プライバシーとセキュリティ',
  'settings.privacy.description': '個人情報を保護',
  'settings.privacy.profile': 'プロフィールの公開設定',
  'settings.privacy.profileDesc': '他のユーザーがプロフィールを閲覧可能',
  'settings.privacy.activity': 'アクティビティステータスを表示',
  'settings.privacy.activityDesc': '友達にオンラインステータスを表示',
  'settings.privacy.analytics': '分析データ収集',
  'settings.privacy.analyticsDesc': '製品体験の改善に協力',
  'settings.privacy.showWorks': '作品の公開設定',
  'settings.privacy.showWorksDesc': '他のユーザーが作品を閲覧可能',
  'settings.privacy.allowComments': 'コメントを許可',
  'settings.privacy.allowCommentsDesc': '他のユーザーが作品にコメント可能',
  'settings.privacy.allowDownload': 'ダウンロードを許可',
  'settings.privacy.allowDownloadDesc': '他のユーザーが作品をダウンロード可能',
  'settings.performance.title': 'パフォーマンス最適化',
  'settings.performance.description': 'システムパフォーマンスとリソース使用を調整',
  'settings.performance.hardware': 'ハードウェアアクセラレーション',
  'settings.performance.hardwareDesc': 'GPUアクセラレーションを使用',
  'settings.performance.preview': 'プレビュー品質',
  'settings.performance.previewDesc': 'プレビュー画像の品質レベル',
  'settings.performance.autoClean': '自動キャッシュクリア',
  'settings.performance.autoCleanDesc': '定期的に一時ファイルをクリア',
  'settings.performance.imageCompression': '画像圧縮',
  'settings.performance.imageCompressionDesc': 'アップロード画像を自動圧縮',
  'settings.performance.lazyLoading': '遅延読み込み',
  'settings.performance.lazyLoadingDesc': 'ページコンテンツの読み込みを遅延',
  'settings.preview.low': '低',
  'settings.preview.medium': '中',
  'settings.preview.high': '高',
  'settings.workflow.title': 'ワークフロー設定',
  'settings.workflow.description': 'AI生成ワークフローをカスタマイズ',
  'settings.workflow.resolution': 'デフォルト解像度',
  'settings.workflow.resolutionDesc': '画像生成のデフォルトサイズ',
  'settings.workflow.saveHistory': '履歴を保存',
  'settings.workflow.saveHistoryDesc': '生成パラメータとプロンプト履歴を保存',
  'settings.workflow.autoTag': 'スマートタグ',
  'settings.workflow.autoTagDesc': '作品に自動的にタグを追加',
  'settings.workflow.template': 'テンプレート機能',
  'settings.workflow.templateDesc': 'ワークフローテンプレートを有効化',
  'settings.file.title': 'ファイル管理',
  'settings.file.description': 'ファイルストレージとバックアップを管理',
  'settings.file.autoBackup': '自動バックアップ',
  'settings.file.autoBackupDesc': '重要なファイルを自動バックアップ',
  'settings.file.backupFrequency': 'バックアップ頻度',
  'settings.file.backupFrequencyDesc': 'バックアップの頻度を選択',
  'settings.file.realtime': 'リアルタイム',
  'settings.file.daily': '毎日',
  'settings.file.weekly': '毎週',
  'settings.file.autoOrganize': 'スマート整理',
  'settings.file.autoOrganizeDesc': 'ファイルを自動分類・整理',
  'settings.file.defaultFormat': 'デフォルトフォーマット',
  'settings.file.defaultFormatDesc': 'ファイル保存のデフォルトフォーマット',
  'settings.social.title': 'ソーシャル機能',
  'settings.social.description': 'ソーシャル機能と権限を管理',
  'settings.social.allowFollow': 'フォローを許可',
  'settings.social.allowFollowDesc': '他のユーザーがフォロー可能',
  'settings.social.allowMessage': 'メッセージを許可',
  'settings.social.allowMessageDesc': '他のユーザーがメッセージ送信可能',
  'settings.social.likeNotify': 'いいね通知',
  'settings.social.likeNotifyDesc': '作品にいいねされたときに通知',
  'settings.social.mentionNotify': 'メンション通知',
  'settings.social.mentionNotifyDesc': 'メンションされたときに通知',
  'settings.security.title': 'アカウントセキュリティ',
  'settings.security.description': 'アカウントセキュリティ保護を強化',
  'settings.security.twoFactor': '二要素認証',
  'settings.security.twoFactorDesc': 'セキュリティ検証レイヤーを追加',
  'settings.security.loginNotify': 'ログイン通知',
  'settings.security.loginNotifyDesc': '新しいデバイスからのログイン時に通知',
  'settings.security.deviceVerify': 'デバイス検証',
  'settings.security.deviceVerifyDesc': '未承認デバイスは検証が必要',
  'settings.security.autoLogout': 'アイドル時自動ログアウト',
  'settings.security.autoLogoutDesc': '長時間操作がない場合に自動ログアウト',
  'settings.button.save': '設定を保存',
  'settings.button.reset': 'デフォルトに戻す',
  'settings.badge.on': 'オン',
  'settings.badge.recommended': '推奨',
  'settings.message.saveSuccess': '設定を保存しました',
  'settings.message.autoSaved': '設定を自動保存しました',
  'settings.message.saveFailed': '保存に失敗しました。もう一度お試しください',
  'settings.message.resetSuccess': '設定をデフォルトに戻しました',
  'settings.autoSaveHint': '設定は自動的に保存されます',
  'settings.confirm.resetTitle': 'リセット確認',
  'settings.confirm.resetContent': 'すべての設定をデフォルト値にリセットしてもよろしいですか？',
  'settings.confirm.reset': 'リセット',
  'settings.confirm.cancel': 'キャンセル',

  // Prompt Version History
  'prompt.version.label.prompt': 'プロンプト',
  'prompt.version.label.negativePrompt': 'ネガティブプロンプト',
  'prompt.version.label.result': '実行結果',
}; 